import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import React__default, { useState, useEffect as useEffect$1, useCallback, useRef as useRef$1, useContext } from 'react';
import { Button as Button$1, Table, Card, Switch as Switch$1, Popover as Popover$1, Alert, notification, Modal as Modal$1, Spin, Slider as Slider$1, Collapse, Input, Radio, Tag, Timeline, Dropdown, Menu, DatePicker, Tooltip } from 'antd';
import { darken, lighten } from 'polished';
import get from 'lodash/get';
import { useLocation, useRouteMatch, Link, useParams, Redirect, NavLink } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Tus from '@uppy/tus';
import DropTarget from '@uppy/drop-target';
import _, { snakeCase, pickBy } from 'lodash';
import { faWindows } from '@fortawesome/free-brands-svg-icons';
import { faQuestionCircle, faClock, faNetworkWired, faFire, faEthernet, faCircle, faPlay, faPause, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import get$1 from 'lodash.get';
import cn from 'classnames';
import Guacamole from 'guacamole-common-js';
import useResizeObserver from 'use-resize-observer/polyfilled';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { X, Clipboard, File, Clock, RefreshCw, Check, Slash, AlertTriangle, Shield, Download, MoreVertical, Upload, CheckSquare, Square } from 'react-feather';
import TextArea from 'antd/lib/input/TextArea';
import ReactDOM from 'react-dom';
import Keycloak from 'keycloak-js';
import debounce from 'lodash/debounce';
import { Field } from 'formik';
import dateFormat from 'dateformat';
import humanizeDuration from 'humanize-duration';
import Table$1 from 'antd/es/table';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import ArrowRightOutlined from '@ant-design/icons/ArrowRightOutlined';
import moment from 'moment';
import SyncOutlined from '@ant-design/icons/SyncOutlined';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 2rem;\n  color: #adb5bd;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: bottom;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background: #fafbfd no-repeat 50% / cover;\n  border-radius: 50%;\n"], ["\n  position: relative;\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 2rem;\n  color: #adb5bd;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: bottom;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background: #fafbfd no-repeat 50% / cover;\n  border-radius: 50%;\n"])));
var initials = function (firstName, lastName) {
    if (lastName)
        return "".concat(firstName.substr(0, 1)).concat(lastName.substr(0, 1));
    return "".concat(firstName.substr(0, 2));
};
function Avatar(_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    return React__default.createElement(Container, null, initials(firstName, lastName));
}
var templateObject_1;

var Filtered = function (props) {
    var filteredProps = __assign({}, props);
    delete filteredProps.colorOverrides;
    delete filteredProps.variant;
    delete filteredProps.ghost;
    delete filteredProps.theming;
    return React__default.createElement(Button$1, __assign({}, filteredProps));
};
var Button = styled(Filtered)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  border: 1px solid\n    ", ";\n\n  &:hover,\n  &:focus {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &:disabled {\n    background: ", " !important;\n    border-color: ", " !important;\n    color: ", " !important;\n  }\n\n  ", ";\n\n  ", "\n"], ["\n  background: ", ";\n  color: ", ";\n  border: 1px solid\n    ", ";\n\n  &:hover,\n  &:focus {\n    background: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &:disabled {\n    background: ", " !important;\n    border-color: ", " !important;\n    color: ", " !important;\n  }\n\n  ", ";\n\n  ", "\n"])), function (p) {
    var _a;
    return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.bg) ||
        p.theme.colors[p.theming].button[p.variant || 'default'].bg;
}, function (p) {
    var _a;
    return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.text) ||
        p.theme.colors[p.theming].button[p.variant || 'default'].text;
}, function (p) {
    var _a;
    return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.border) ||
        p.theme.colors[p.theming].button[p.variant || 'default'].border;
}, function (p) {
    var _a;
    return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.bg)
        ? darken(0.1, p.colorOverrides.bg)
        : p.theme.colors[p.theming].button[p.variant || 'default'].hoverBg;
}, function (p) {
    return p.theme.colors[p.theming].button[p.variant || 'default'].hoverText;
}, function (p) {
    var _a;
    return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.border)
        ? p.colorOverrides.border !== 'transparent'
            ? darken(0.1, p.colorOverrides.border)
            : 'transparent'
        : p.theme.colors[p.theming].button[p.variant || 'default'].hoverBorder;
}, function (p) { return p.theme.colors.common.grey100; }, function (p) { return p.theme.colors.common.grey200; }, function (p) { return p.theme.colors.common.grey300; }, function (p) {
    return p.ghost && css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      box-shadow: none;\n      background: transparent;\n      color: ", ";\n\n      &:hover,\n      &:focus {\n        background: ", ";\n        border-color: ", ";\n      }\n\n      &:disabled {\n        background: ", " !important;\n        border-color: ", " !important;\n        color: ", " !important;\n      }\n    "], ["\n      box-shadow: none;\n      background: transparent;\n      color: ", ";\n\n      &:hover,\n      &:focus {\n        background: ", ";\n        border-color: ", ";\n      }\n\n      &:disabled {\n        background: ", " !important;\n        border-color: ", " !important;\n        color: ", " !important;\n      }\n    "])), function (p) {
        var _a;
        return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.text) ||
            p.theme.colors[p.theming].button[p.variant || 'default'].bg;
    }, function (p) {
        var _a;
        return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.text) ||
            p.theme.colors[p.theming].button[p.variant || 'default'].bg;
    }, function (p) {
        var _a;
        return ((_a = p.colorOverrides) === null || _a === void 0 ? void 0 : _a.text) ||
            p.theme.colors[p.theming].button.primary.bg;
    }, function (p) { return p.theme.colors.common.grey100; }, function (p) { return p.theme.colors.common.grey200; }, function (p) { return p.theme.colors.common.grey300; });
}, function (p) {
    return p.loading && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      svg.anticon-spin {\n        margin-top: -6px;\n      }\n    "], ["\n      svg.anticon-spin {\n        margin-top: -6px;\n      }\n    "])));
});
var templateObject_1$1, templateObject_2, templateObject_3;

var CompactTable = styled(Table)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  .ant-pagination-item-link {\n    color: inherit;\n    width: 32px;\n    svg {\n      vertical-align: unset;\n    }\n  }\n  tbody > tr .ant-table {\n    margin: -9px -9px 24px -9px;\n    border-left: none;\n    border-right: none;\n  }\n  &.ant-table,\n  * .ant-table {\n    & + ul.ant-table-pagination.ant-pagination {\n      float: left;\n      margin: 16px;\n    }\n\n    border: 1px solid\n      ", ";\n    tbody,\n    thead {\n      > tr {\n        cursor: pointer;\n        &:last-child {\n          :not(:first-child) {\n            .ant-table-cell {\n              border: none;\n            }\n          }\n        }\n        .ant-table-cell {\n          padding: 8px 8px;\n\n          .ant-table-column-sorters {\n            padding: 0;\n          }\n        }\n      }\n    }\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"], ["\n  .ant-pagination-item-link {\n    color: inherit;\n    width: 32px;\n    svg {\n      vertical-align: unset;\n    }\n  }\n  tbody > tr .ant-table {\n    margin: -9px -9px 24px -9px;\n    border-left: none;\n    border-right: none;\n  }\n  &.ant-table,\n  * .ant-table {\n    & + ul.ant-table-pagination.ant-pagination {\n      float: left;\n      margin: 16px;\n    }\n\n    border: 1px solid\n      ", ";\n    tbody,\n    thead {\n      > tr {\n        cursor: pointer;\n        &:last-child {\n          :not(:first-child) {\n            .ant-table-cell {\n              border: none;\n            }\n          }\n        }\n        .ant-table-cell {\n          padding: 8px 8px;\n\n          .ant-table-column-sorters {\n            padding: 0;\n          }\n        }\n      }\n    }\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"])), function (p) {
    return p.bordered !== false ? p.theme.colors.common.gray200 : 'transparent';
});
var templateObject_1$2;

function propsToFlex(prop) {
    switch (prop) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'between':
            return 'space-between';
        case 'around':
            return 'space-around';
        case 'center':
            return 'center';
    }
}
var Flex = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"], ["\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (p) { return (p.inline ? 'inline-flex' : 'flex'); }, function (p) { return (p.column ? 'column' : 'row'); }, function (_a) {
    var _b = _a.v, v = _b === void 0 ? 'start' : _b, _c = _a.h, h = _c === void 0 ? 'start' : _c, column = _a.column;
    return propsToFlex(column ? h : v);
}, function (_a) {
    var _b = _a.v, v = _b === void 0 ? 'start' : _b, _c = _a.h, h = _c === void 0 ? 'start' : _c, column = _a.column;
    return propsToFlex(column ? v : h);
});
var templateObject_1$3;

var Container$1 = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "className"]);
    return (React__default.createElement("div", __assign({ className: "container ".concat(className) }, rest), children));
};
var Col = function (_a) {
    var width = _a.width, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, className = _a.className, children = _a.children, rest = __rest(_a, ["width", "xs", "sm", "md", "lg", "xl", "className", "children"]);
    var classes = [];
    if (width)
        classes.push("col-".concat(width));
    if (!width)
        classes.push("col");
    if (xs)
        classes.push("col-xs-".concat(xs));
    if (sm)
        classes.push("col-sm-".concat(sm));
    if (md)
        classes.push("col-md-".concat(md));
    if (lg)
        classes.push("col-lg-".concat(lg));
    if (xl)
        classes.push("col-xl-".concat(xl));
    if (className)
        classes.push(className);
    return (React__default.createElement("div", __assign({ className: classes.join(' ') }, rest), children));
};
var Row = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["children", "className"]);
    return (React__default.createElement("div", __assign({ className: "".concat(className, " row") }, rest), children));
};
var Grid = {
    Container: Container$1,
    Col: Col,
    Row: Row,
};

var Container$2 = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 2rem;\n  color: #adb5bd;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: bottom;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background: #fafbfd no-repeat 50% / cover;\n  border-radius: 50%;\n"], ["\n  position: relative;\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 2rem;\n  color: #adb5bd;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: bottom;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background: #fafbfd no-repeat 50% / cover;\n  border-radius: 50%;\n"])));
var initials$1 = function (name) {
    if (!name)
        return 'XX';
    var _a = __read(name.split(' '), 2), firstName = _a[0], lastName = _a[1];
    if (lastName)
        return "".concat(firstName.substr(0, 1)).concat(lastName.substr(0, 1));
    return "".concat(firstName.substr(0, 2));
};
function Initials(_a) {
    var name = _a.name;
    return React__default.createElement(Container$2, null, initials$1(name));
}
var templateObject_1$4;

var bounceDelay = keyframes(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n"], ["\n0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n"])));
var Bounce = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  width: 12px;\n  height: 12px;\n  background-color: var(--primary);\n\n  border-radius: 100%;\n  display: inline-block;\n  animation: ", " 1.4s infinite ease-in-out both;\n"], ["\n  width: 12px;\n  height: 12px;\n  background-color: var(--primary);\n\n  border-radius: 100%;\n  display: inline-block;\n  animation: ", " 1.4s infinite ease-in-out both;\n"])), bounceDelay);
var Bounce1 = styled(Bounce)(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  animation-delay: -0.32s;\n"], ["\n  animation-delay: -0.32s;\n"])));
var Bounce2 = styled(Bounce)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  animation-delay: -0.16s;\n"], ["\n  animation-delay: -0.16s;\n"])));
var Spinner = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
function Loading(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement(Spinner, __assign({}, props),
        React__default.createElement(Bounce1, { className: "bounce1" }),
        React__default.createElement(Bounce2, { className: "bounce2" }),
        React__default.createElement(Bounce, { className: "bounce3" })));
}
var templateObject_1$5, templateObject_2$1, templateObject_3$1, templateObject_4, templateObject_5;

function useDebounce(value, delay) {
    // State and setters for debounced value
    var _a = __read(useState(value), 2), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect$1(function () {
        // Update debounced value after delay
        var handler = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function () {
            clearTimeout(handler);
        };
    }, [value, delay] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}

var parseFlatJsonToForm = function (body) {
    var keys = Object.keys(body);
    var stringified = keys.map(function (x) { return "".concat(x, "=").concat(body[x]); });
    return stringified.join('&');
};
function useFetch(_a) {
    var _this = this;
    var url = _a.url, dataParser = _a.dataParser, formdata = _a.formdata, _b = _a.defaultValue, defaultValue = _b === void 0 ? null : _b, _c = _a.initialFetch, initialFetch = _c === void 0 ? true : _c, _d = _a.options, options = _d === void 0 ? {} : _d, onSucces = _a.onSucces, onFail = _a.onFail, onEmpty = _a.onEmpty, body = _a.body, _e = _a.bearer, bearer = _e === void 0 ? sessionStorage.getItem('token') || undefined : _e, _f = _a.type, type = _f === void 0 ? 'json' : _f;
    var _g = __read(useState(1), 2), count = _g[0], setCount = _g[1];
    var _h = __read(useState(initialFetch ? 0 : 1), 2), prevCount = _h[0], setPrevCount = _h[1];
    var _j = __read(useState({
        loading: initialFetch,
        data: defaultValue,
        empty: false,
        error: false,
    }), 2), result = _j[0], setResult = _j[1];
    var updateCount = function () { return setCount(count + 1); };
    var reset = function () {
        setResult({
            loading: initialFetch,
            data: defaultValue,
            empty: false,
            error: false,
        });
    };
    var fetcher = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var optionsBody, api, newResult, data, _a, isArray, hasData, dataMap, newResult, newResult, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    optionsBody = body;
                    if (formdata)
                        optionsBody = parseFlatJsonToForm(optionsBody);
                    if (!formdata)
                        optionsBody = JSON.stringify(optionsBody);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 9, , 10]);
                    setResult(__assign(__assign({}, result), { loading: true }));
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { body: optionsBody, credentials: 'include', headers: __assign({ 'Content-Type': formdata
                                    ? 'application/x-www-form-urlencoded; charset=UTF-8'
                                    : 'application/json', Authorization: "Bearer ".concat(bearer) }, options.headers) }))];
                case 2:
                    api = _b.sent();
                    if (!(api.status >= 300 || api.status < 200)) return [3 /*break*/, 3];
                    newResult = {
                        loading: false,
                        data: defaultValue,
                        empty: true,
                        error: api.status,
                    };
                    if (onFail)
                        onFail(newResult);
                    setResult(newResult);
                    throw new Error();
                case 3:
                    if (!(type === 'json')) return [3 /*break*/, 5];
                    return [4 /*yield*/, api.json()];
                case 4:
                    _a = _b.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, api.text()];
                case 6:
                    _a = _b.sent();
                    _b.label = 7;
                case 7:
                    data = _a;
                    isArray = Array.isArray(data);
                    hasData = false;
                    if (isArray)
                        hasData = data.length > 0;
                    if (!isArray && typeof data === 'object')
                        hasData = Object.keys(data).length > 0;
                    if (typeof data === 'string' || typeof data === 'number')
                        hasData = true;
                    if (hasData) {
                        dataMap = dataParser ? dataParser(data) : data;
                        newResult = {
                            loading: false,
                            data: dataMap,
                            empty: false,
                            error: false,
                        };
                        if (onSucces)
                            onSucces(newResult);
                        setResult(newResult);
                    }
                    else {
                        newResult = {
                            loading: false,
                            data: defaultValue,
                            empty: true,
                            error: false,
                        };
                        if (onEmpty)
                            onEmpty(newResult);
                        setResult(newResult);
                    }
                    _b.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_1 = _b.sent();
                    console.error(e_1);
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [url, dataParser, defaultValue, options]);
    useEffect$1(function () {
        if (count !== prevCount) {
            fetcher();
            setPrevCount(count);
        }
    }, [fetcher, prevCount, count]);
    return [result, updateCount, reset];
}

var uniq = function (arr, removeNullOrUndefined) {
    var uniqueArr = __spreadArray([], __read(new Set(arr)), false);
    if (removeNullOrUndefined)
        return uniqueArr.filter(function (x) { return x != null; });
    return uniqueArr;
};
var arrayRemove = function (arr, elementToRemove, key) {
    if (key)
        return arr.filter(function (el) { return el[key] !== elementToRemove; });
    return arr.filter(function (el) { return el !== elementToRemove; });
};
var deepCopy = function (arr) { return JSON.parse(JSON.stringify(arr)); };
function arrayContains(arr, value) {
    if (typeof value !== 'object')
        return arr.findIndex(function (x) { return x === value; }) > -1;
}
function updateObjectInArray(array, adjustedData, options) {
    var hasIndex = !!String(options === null || options === void 0 ? void 0 : options.index);
    if (!options || (!hasIndex && !options.keyvalue))
        return [];
    var arrayIndex = hasIndex
        ? options.index
        : array.findIndex(function (a) { var _a, _b; return a[((_a = options.keyvalue) === null || _a === void 0 ? void 0 : _a.key) || 'undefined'] === ((_b = options.keyvalue) === null || _b === void 0 ? void 0 : _b.value); });
    return array.map(function (item, index) {
        if (index !== arrayIndex) {
            // This isn't the item we care about - keep it as-is
            return item;
        }
        // Otherwise, this is the one we want - return an updated value
        return __assign(__assign({}, item), adjustedData);
    });
}

var searchFilter = function (searchProps, value, dataset) {
    return dataset.filter(function (item) {
        var propString = '';
        if (Array.isArray(searchProps)) {
            searchProps.map(function (prop) {
                var propValue = get(item, prop);
                if (propValue)
                    propString += " ".concat(propValue);
            });
        }
        else {
            propString = dataset[searchProps];
        }
        return propString.toLowerCase().includes(value.toLowerCase());
    });
};
var getNested = function (item, key) {
    return key.includes('.') ? get(item, key) : item[key];
};
var createFilters = function (keys, dataSet, customLabel, customHeading) {
    var filterValues = {};
    keys.forEach(function (key) {
        filterValues[key] = {
            label: customHeading ? customHeading(key) : key,
            options: uniq(dataSet.map(function (item) { return getNested(item, key); })).map(function (item) {
                return {
                    label: (customLabel ? customLabel(key, item) : item) || 'Undefined',
                    value: item,
                };
            }),
        };
        if (filterValues[key].options.length <= 1)
            delete filterValues[key];
    });
    return filterValues;
};

var useFilters = function (dataSet, filterKeys, searchKeys, customFilterLabel, customHeading) {
    var _a = __read(useState(function () {
        return createFilters(filterKeys, dataSet, customFilterLabel, customHeading);
    }), 2), availableFilters = _a[0], setAvailableFilters = _a[1];
    var _b = __read(useState({}), 2), enabledFilters = _b[0], setEnabledFilters = _b[1];
    var _c = __read(useState(dataSet), 2), filteredData = _c[0], setFilteredData = _c[1];
    var _d = __read(useState(''), 2), searchValue = _d[0], setSearchValue = _d[1];
    var toggleFiltersOnMount = function (filters) {
        setEnabledFilters(filters);
    };
    var toggleFilter = function (key, value) {
        var _a;
        var filterExists = enabledFilters[key] != null;
        var index = (_a = enabledFilters[key]) === null || _a === void 0 ? void 0 : _a.findIndex(function (x) { return x === value; });
        var newFilters = __assign({}, enabledFilters);
        if (!filterExists || index < 0) {
            if (!filterExists)
                newFilters[key] = [];
            newFilters[key].push(value);
        }
        else {
            if (newFilters[key].length === 1) {
                delete newFilters[key];
            }
            else {
                newFilters[key].splice(index, 1);
            }
        }
        setEnabledFilters(newFilters);
    };
    useEffect$1(function () {
        setAvailableFilters(createFilters(filterKeys, dataSet, customFilterLabel, customHeading));
    }, [filterKeys, dataSet]);
    useEffect$1(function () {
        if (dataSet.length < 1) {
            setFilteredData([]);
            return;
        }
        // let newData: any[] = [...dataSet];
        var newData = dataSet;
        filterKeys.forEach(function (key) {
            if (!enabledFilters[key])
                return;
            newData = newData.filter(function (item) { var _a; return !!((_a = enabledFilters[key]) === null || _a === void 0 ? void 0 : _a.includes(getNested(item, key))); });
        });
        if (searchKeys && searchValue) {
            newData = searchFilter(searchKeys, searchValue, newData);
        }
        setFilteredData(newData);
    }, [enabledFilters, dataSet, filterKeys, searchValue]);
    return [
        availableFilters,
        toggleFilter,
        filteredData,
        { value: searchValue, set: setSearchValue },
        toggleFiltersOnMount,
    ];
};

// interface UsePageQuery
function usePageQuery(totalPages, customUrl) {
    var pages = Math.ceil(totalPages);
    var location = useLocation();
    var params = new URLSearchParams(location.search);
    var _a = __read(useState(parseInt(params.get('page') || '1')), 2), page = _a[0], setPage = _a[1];
    var history = createBrowserHistory();
    var url = useRouteMatch().url;
    var sanitizedSetPage = function (newPage) {
        if (newPage !== page)
            setPage(newPage);
    };
    useEffect$1(function () {
        if (!pages && page !== 1) {
            setPage(1);
            return;
        }
        if ((pages && page - 1 > pages) || isNaN(page) || page < 1)
            setPage(1);
        var hasPage = params.has('page');
        params.delete('token');
        params.delete('uid');
        var paramsModifier = hasPage ? 'set' : 'append';
        params[paramsModifier]('page', "".concat(page));
        var historyModifier = 'replace';
        history[historyModifier]("".concat(customUrl || url, "?").concat(params.toString()));
    }, [history, page, params, url, pages, customUrl]);
    return [page, sanitizedSetPage];
}

var useEffect = useEffect$1, useRef = useRef$1;
function useInterval(callback, delay) {
    var savedCallback = useRef(null);
    useEffect(function () {
        if (delay === null)
            return;
        savedCallback.current = callback;
    });
    useEffect(function () {
        if (delay === null)
            return;
        function tick() {
            if (savedCallback.current !== null) {
                savedCallback.current();
            }
        }
        var id = setInterval(tick, delay);
        return function () { return clearInterval(id); };
    }, [delay]);
}

var REGEXP_LONGITUDE = new RegExp(/^(-?\d{1,3}(\.|,)(\d{6,20})?)$/);
var REGEXP_LATITUDE = new RegExp(/^(-?\d{1,2}(\.|,)(\d{6,20})?)$/);
var REGEXP_EMPTY = new RegExp(/^$|\s$/);
var REGEXP_IP = new RegExp(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/);
var REGEXP_UUID = new RegExp(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
var REGEXP_TIMEPERIOD = new RegExp(/^(0[0-9]{1}|[1-9]{1}[0-9]{1,2}|[0]{2})\:(0[0-9]{1}|[1-5]{1}[0-9]{1})\:(0[0-9]{1}|[1-5]{1}[0-9]{1})/);
var regExp = {
    longitude: REGEXP_LONGITUDE,
    latitude: REGEXP_LATITUDE,
    empty: REGEXP_EMPTY,
    ip: REGEXP_IP,
    uuid: REGEXP_UUID,
    timeperiod: REGEXP_TIMEPERIOD,
};

var CONSTANT = 'CONSTANT';
var constants = {
    CONSTANT: CONSTANT,
};

function timeOffsetFormat(offset, unit) {
    var ms = offset;
    if (typeof offset === 'string')
        ms = parseInt(offset);
    if (typeof ms !== 'number' || isNaN(ms))
        throw Error('invalid timeOffset');
    if (unit === 'seconds')
        ms = ms * 1000;
    if (unit === 'minutes')
        ms = ms * 1000 * 60;
    if (unit === 'hours')
        ms = ms * 1000 * 60 * 60;
    if (unit === 'days')
        ms = ms * 1000 * 60 * 60 * 24;
    var months = Math.floor(ms / 1000 / 60 / 60 / 24 / 30);
    if (months > 0)
        return "".concat(months, " ").concat(months === 1 ? 'month' : 'months');
    var days = Math.floor(ms / 1000 / 60 / 60 / 24);
    if (days > 0)
        return "".concat(days, " ").concat(days === 1 ? 'day' : 'days');
    var hours = Math.floor(ms / 1000 / 60 / 60);
    if (hours > 0)
        return "".concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours');
    var minutes = Math.floor(ms / 1000 / 60);
    if (minutes > 0)
        return "".concat(minutes, " ").concat(minutes === 1 ? 'minute' : 'minutes');
    var seconds = Math.floor(ms / 1000);
    if (seconds > 0)
        return "".concat(seconds, " ").concat(seconds === 1 ? 'second' : 'seconds');
    throw new Error("Time offset couldn't be parsed");
}
function timeOffsetLabel(date) {
    var siteDate = new Date(date);
    var currentDate = new Date();
    var diff = new Date(currentDate - siteDate);
    return " (".concat(timeOffsetFormat(diff), ")");
}

var openNotificationWithIcon = function (constructor, message, description, duration) {
    if (duration === void 0) { duration = 10; }
    constructor({
        message: message,
        description: description,
        duration: duration,
    });
};

function antdToEsSort(sort) {
    switch (sort) {
        case 'ascend':
            return 'asc';
        case 'descend':
            return 'desc';
        default:
            return undefined;
    }
}
function esToAntdSort(sort) {
    switch (sort) {
        case 'asc':
            return 'ascend';
        case 'desc':
            return 'descend';
        default:
            return undefined;
    }
}

// default sorting function, parameters a & b must b strings or numbers
function defaultSort(a, b) {
    var comparison = 0;
    if (a > b) {
        comparison = 1;
    }
    else if (a < b) {
        comparison = -1;
    }
    return comparison;
}
// extension of the default sorting function for usage with arrays of object literals
// either single or multiple object literal properties can be sent as a parameter
// multiple properties need to be passed in as an array and then will be joined to a string so defaultSort can be used
function objectArraySort(a, b, props) {
    var propA;
    var propB;
    if (typeof props === 'string') {
        if (a[props] === null || b[props] === null) {
            return 0;
        }
        if (props.includes('.')) {
            propA = "".concat(get(a, props)).toUpperCase();
            propB = "".concat(get(b, props)).toUpperCase();
        }
        else {
            propA = a[props].toUpperCase();
            propB = b[props].toUpperCase();
        }
    }
    else {
        propA = props.map(function (prop) { return a[prop].toUpperCase(); }).join();
        propB = props.map(function (prop) { return b[prop].toUpperCase(); }).join();
    }
    return defaultSort(propA, propB);
}
function sortByCustomOrder(a, b, order, key) {
    var _a = order.indexOf(a[key]);
    var _b = order.indexOf(b[key]);
    return defaultSort(_a, _b);
}

var parseFlatJsonToForm$1 = function (body) {
    var keys = Object.keys(body);
    var stringified = keys.map(function (x) { return "".concat(x, "=").concat(body[x]); });
    return stringified.join('&');
};
/**
 * Return a copy of `obj` with all CamelCase keys converted into snake_case.
 * @param obj
 */
var snake = function (obj) {
    return Object.assign.apply(Object, __spreadArray([{}], __read(Object.entries(obj).map(function (_a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (_b = {},
            _b[snakeCase(key)] = value,
            _b);
    })), false));
};

var IconRequestConnection = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, rest),
        React__default.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React__default.createElement("path", { d: "M9 16H2c-.552 0-1 .488-1 1.09v3.82c0 .602.448 1.09 1 1.09h7c.552 0 1-.488 1-1.09v-3.82c0-.602-.448-1.09-1-1.09zM2 16v-2.221c0-.688.324-1.353.912-1.864.587-.51 1.396-.832 2.268-.9.872-.07 1.746.118 2.452.526.706.408 1.194 1.008 1.368 1.683" }),
            React__default.createElement("path", { d: "M3 7V5a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6", strokeWidth: "2" }))));
};

var IconStartConnection = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, rest),
        React__default.createElement("g", { stroke: "currentColor", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React__default.createElement("path", { d: "M10 10l-4 4 4 4M1 22l4-4-4-4" }),
            React__default.createElement("path", { d: "M4 6.75V4.875c0-.497.2-.974.557-1.326C4.913 3.198 5.397 3 5.9 3h15.2c.504 0 .987.198 1.343.55.357.35.557.828.557 1.325v11.25c0 .497-.2.974-.557 1.326-.356.351-.84.549-1.343.549h-5.7", strokeWidth: "2" }))));
};

var IconMcAfee = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, rest),
        React__default.createElement("path", { d: "M24 9.647L3 0v38.353L24 48l21-9.647V0L24 9.647zm12.444 23.25l-12.385 5.681-12.375-5.681V13.379l12.375 5.681 12.385-5.681v19.518z", fill: "currentColor", fillRule: "nonzero" })));
};

var IconWindows = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, rest),
        React__default.createElement("path", { d: "M0 6.61l19.67-2.716v19.001H0V6.61zm0 34.77l19.67 2.71V25.324H0V41.38zm21.836 3.01L48 48V25.323H21.836v19.066zm0-40.769v19.293H48V0L21.836 3.621z", fill: "currentColor", fillRule: "nonzero" })));
};

var sitePrimary = '#417e80';
var siteSecondary = '#5187D2';
var centerPrimary = '#004f9b';
var centerSecondary = '#417e80';
var buttonColors = function (config) {
    var defaultHoverBg = darken(0.1, config.bg);
    return {
        bg: config.bg,
        text: config.text,
        border: config.border || config.bg,
        hoverBg: config.hoverBg || defaultHoverBg,
        hoverText: config.hoverText || config.text,
        hoverBorder: config.hoverBg || config.hoverBg || defaultHoverBg,
    };
};
var colorSet = function (config) { return ({
    light: lighten(config.light || 0.2, config.color),
    main: config.color,
    dark: darken(config.dark || 0.2, config.color),
}); };
var buttonSet = function (colors) { return ({
    primary: buttonColors({
        bg: colors.primary,
        border: colors.primary,
        text: '#FFFFFF',
    }),
    secondary: buttonColors({
        bg: colors.secondary,
        border: colors.primary,
        text: '#FFFFFF',
    }),
    default: {
        bg: '#FFFFFF',
        text: 'rgba(0,0,0,.65)',
        border: 'rgba(0,0,0,.65)',
        hoverBg: 'rgba(0,0,0,.44)',
        hoverText: '#FFFFFF',
        hoverBorder: 'rgba(0,0,0,.44)',
    },
}); };
var colors = {
    site: {
        primary: colorSet({ color: sitePrimary }),
        secondary: colorSet({ color: siteSecondary }),
        button: buttonSet({ primary: sitePrimary, secondary: siteSecondary }),
    },
    center: {
        primary: colorSet({ color: centerPrimary }),
        secondary: colorSet({ color: centerSecondary }),
        button: buttonSet({ primary: centerPrimary, secondary: centerSecondary }),
    },
    common: {
        gray100: '#f8f9fa',
        gray200: '#e9ecef',
        gray300: '#dee2e6',
        gray400: '#ced4da',
        gray500: '#adb5bd',
        gray600: '#868e96',
        gray700: '#495057',
        gray800: '#343a40',
        gray900: '#212529',
        grey100: '#f8f9fa',
        grey200: '#e9ecef',
        grey300: '#dee2e6',
        grey400: '#ced4da',
        grey500: '#adb5bd',
        grey600: '#868e96',
        grey700: '#495057',
        grey800: '#343a40',
        grey900: '#212529',
        blue: '#004f9b',
        azure: '#45aaf2',
        indigo: '#6574cd',
        purple: '#a55eea',
        pink: '#f66d9b',
        red: '#fa4654',
        orange: '#fd9644',
        yellow: '#f1c40f',
        lime: '#7bd235',
        green: '#5eba00',
        teal: '#2bcbba',
        cyan: '#17a2b8',
    },
};

var spacing = {
    1: '.25rem',
    2: '.50rem',
    3: '.75rem',
    4: '1rem',
    5: '1.5rem',
    6: '2rem',
    7: '2.5rem',
    8: '3rem',
    9: '4rem',
    10: '5rem',
    11: '6rem',
    12: '8rem',
    13: '10rem',
    14: '12rem',
    15: '14rem',
    16: '16rem',
    17: '18rem',
    18: '20rem',
    auto: 'auto',
    px: '1px',
    full: '100%',
};

var grid = {
    columns: 12,
    gutter: 1,
    breakpoints: { default: -1, xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 },
};

var theme = {
    colors: colors,
    spacing: spacing,
    grid: grid,
};

var fontSizeBase = 1;
var fontSizeUnit = 'rem';
var MssGlobalStyles = createGlobalStyle(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  /* id selector to increase specificity */\n  #root {\n    h1, h2, h3, h4, h5, h6 {\n      color: rgba(0, 0, 0, 0.65);\n      line-height: 1.2;\n      font-weight: 600;\n    }\n\n    h1 { font-size: ", "", " };\n    h2 { font-size: ", "", " };\n    h3 { font-size: ", "", " };\n    h4 { font-size: ", "", " };\n    h5 { font-size: ", "", " };\n    h6 { font-size: ", "", " };\n\n    .text-muted {\n      color: ", ";\n    }\n    \n  }\n"], ["\n  /* id selector to increase specificity */\n  #root {\n    h1, h2, h3, h4, h5, h6 {\n      color: rgba(0, 0, 0, 0.65);\n      line-height: 1.2;\n      font-weight: 600;\n    }\n\n    h1 { font-size: ", "", " };\n    h2 { font-size: ", "", " };\n    h3 { font-size: ", "", " };\n    h4 { font-size: ", "", " };\n    h5 { font-size: ", "", " };\n    h6 { font-size: ", "", " };\n\n    .text-muted {\n      color: ", ";\n    }\n    \n  }\n"])), fontSizeBase * 2, fontSizeUnit, fontSizeBase * 1.75, fontSizeUnit, fontSizeBase * 1.5, fontSizeUnit, fontSizeBase * 1.25, fontSizeUnit, fontSizeBase * 1, fontSizeUnit, fontSizeBase * 0.875, fontSizeUnit, function (p) { return p.theme.colors.common.grey600; });
var templateObject_1$6;

var bounceDelay$1 = keyframes(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n"], ["\n0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n"])));
var templateObject_1$7;

var IconVideo = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: theme.colors.common.gray700, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, rest),
        React__default.createElement("polygon", { points: "23 7 16 12 23 17 23 7" }),
        React__default.createElement("rect", { x: "1", y: "5", width: "15", height: "14", rx: "2", ry: "2" })));
};

var IconFilm = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: theme.colors.common.gray700, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, rest),
        React__default.createElement("rect", { x: "2", y: "2", width: "20", height: "20", rx: "2.18", ry: "2.18" }),
        React__default.createElement("line", { x1: "7", y1: "2", x2: "7", y2: "22" }),
        React__default.createElement("line", { x1: "17", y1: "2", x2: "17", y2: "22" }),
        React__default.createElement("line", { x1: "2", y1: "12", x2: "22", y2: "12" }),
        React__default.createElement("line", { x1: "2", y1: "7", x2: "7", y2: "7" }),
        React__default.createElement("line", { x1: "2", y1: "17", x2: "7", y2: "17" }),
        React__default.createElement("line", { x1: "17", y1: "17", x2: "22", y2: "17" }),
        React__default.createElement("line", { x1: "17", y1: "7", x2: "22", y2: "7" })));
};

var Logo = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "178.638", height: "27.184", viewBox: "0 0 47.265 7.192" }, rest),
        React__default.createElement("path", { d: "M43.724 7.06a8.216 8.216 0 0 1 3.408-3.52c0 .005-3.405-3.404-3.405-3.408-1.705 1.71-2.712 2.705-3.408 3.409-.001 0 .006.004 0 0 1.441.785 2.561 1.926 3.405 3.52", fill: "#ffee01" }),
        React__default.createElement("path", { d: "M3.011 6.094h-.772v-2.08L.132 1.028h.977l1.51 2.24L4.142 1.03h.967L3.01 3.997z", fill: "#fff" }),
        React__default.createElement("path", { d: "M6.902.876c-.383 0-2.481.17-2.481 2.723 0 2.407 2.101 2.626 2.504 2.63.423.002 2.5-.245 2.5-2.694 0-2.322-1.869-2.66-2.523-2.66m.051 4.685c-.75 0-1.75-.437-1.75-2.015 0-1.44.953-2.013 1.702-2.013.686 0 1.733.448 1.733 2.08 0 1.602-1.155 1.948-1.685 1.948M10.576 6.092h-.768V1.025l.816.002v2.397l2.388-2.397h1.049l-2.107 2.114 2.273 2.948-.988.004-1.877-2.482-.786.743z", fill: "#fff" }),
        React__default.createElement("path", { d: "M16.057.863c-.732.025-2.551.399-2.551 2.642 0 2.469 1.969 2.718 2.574 2.715.677-.004 2.45-.477 2.458-2.696.01-2.66-2.51-2.66-2.481-2.661m-.004 4.69c-.733 0-1.741-.391-1.741-2.01 0-1.546 1.012-2.013 1.723-2.013.894 0 1.691.661 1.691 1.98 0 1.703-1.081 2.044-1.673 2.044M21.393 3.426l2.196.002-.007 2.639h-.608l-.089-.489c-.475.464-.95.625-1.716.623-1.107-.002-2.318-.88-2.318-2.684 0-1.225.778-2.626 2.404-2.62.862 0 2.061.288 2.264 1.62l-.795.004c-.101-.336-.387-.992-1.402-.992-.832 0-1.653.506-1.653 2.048 0 1.459.913 1.999 1.613 1.999.684 0 1.33-.233 1.591-1.452h-1.476l-.004-.698M26.342 1.035l-1.04.002-1.62 5.052h.83l.431-1.402 1.98-.002.558 1.392.85-.008zm-1.204 2.998l.69-2.27.148.406.69 1.864zM27.397 1.028h.866c.68 2.75.814 3.232.964 3.77.12-.506.366-1.17 1.033-3.77h.783c.79 2.803.908 3.236 1.08 3.8.12-.47.285-1.029.96-3.8h.82l-1.356 5.051-.811.01c-.658-2.242-.738-2.514-1.071-3.695-.274.942-.328 1.185-1.031 3.69H28.8l-1.403-5.056M35.88 1.02h-.998l-1.79 5.062h.8l.46-1.354 2.014.002.49 1.349.837-.002zm-1.288 3.038l.779-2.243v-.01l.784 2.254z", fill: "#fff" })));
};

function Brave(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 112.4 131.9" }, props),
        React__default.createElement("defs", null,
            React__default.createElement("linearGradient", { id: "prefix__a", x1: -475.07, x2: -474.07, y1: 675.83, y2: 675.83, gradientTransform: "matrix(112.31 0 0 -131.86 53355.92 89180.8)", gradientUnits: "userSpaceOnUse" },
                React__default.createElement("stop", { offset: 0, stopColor: "#f50" }),
                React__default.createElement("stop", { offset: 0.41, stopColor: "#f50" }),
                React__default.createElement("stop", { offset: 0.58, stopColor: "#ff2000" }),
                React__default.createElement("stop", { offset: 1, stopColor: "#ff2000" })),
            React__default.createElement("linearGradient", { id: "prefix__b", x1: -474.21, x2: -473.23, y1: 659.13, y2: 659.13, gradientTransform: "matrix(93.22 0 0 -23.76 44217.1 15672.73)", gradientUnits: "userSpaceOnUse" },
                React__default.createElement("stop", { offset: 0, stopColor: "#ff452a" }),
                React__default.createElement("stop", { offset: 1, stopColor: "#ff2000" }))),
        React__default.createElement("g", { "data-name": "Calque 2" },
            React__default.createElement("g", { "data-name": "Layer 1" },
                React__default.createElement("g", { "data-name": "build-icons/Stable" },
                    React__default.createElement("path", { fill: "url(#prefix__a)", d: "M108.4 31.6l3.1-7.6s-3.9-4.2-8.7-9-14.9-2-14.9-2L76.4 0H35.9L24.4 13.1s-10.1-2.8-14.9 2-8.7 9-8.7 9l3.1 7.6L0 42.9s11.6 43.8 12.9 49.2c2.7 10.5 4.5 14.6 12.1 20s21.3 14.6 23.6 16 5.1 3.8 7.6 3.8 5.3-2.4 7.6-3.8 16-10.7 23.6-16 9.4-9.4 12.1-20c1.4-5.4 12.9-49.2 12.9-49.2z" }),
                    React__default.createElement("path", { fill: "#fff", d: "M84.7 21.4s14.8 17.9 14.8 21.8-1.9 4.8-3.8 6.8-10.1 10.7-11.1 11.8-3.2 2.8-2 5.9 3.2 6.9 1.1 10.9-5.7 6.6-8 6.1-7.8-3.3-9.8-4.6-8.3-6.5-8.3-8.5 6.6-5.6 7.8-6.4 6.7-4 6.8-5.2.1-1.6-1.6-4.7-4.6-7.2-4.1-9.9 5.2-4.1 8.6-5.4 9.9-3.7 10.7-4.1.6-.7-1.9-1-9.4-1.2-12.6-.3-8.5 2.2-9 2.9-.8.7-.4 3.2 2.8 14.2 3 16.3.7 3.5-1.6 4a56.78 56.78 0 01-7.3 1.4 56.78 56.78 0 01-7.3-1.4c-2.2-.5-1.8-1.9-1.6-4s2.5-13.8 3-16.3.1-2.5-.4-3.2-5.8-2-9-2.9-10.1 0-12.6.3-2.7.6-1.9 1 7.3 2.8 10.7 4.1 8.1 2.7 8.6 5.4-2.4 6.8-4.1 9.9-1.7 3.4-1.6 4.7 5.6 4.4 6.8 5.2 7.8 4.4 7.8 6.4-6.3 7.2-8.3 8.5-7.4 4.1-9.8 4.6-5.9-2.2-8-6.1-.2-7.8 1.1-10.9-.9-4.7-2-5.9c-.8-1.2-8.9-9.9-10.8-11.8s-3.7-3-3.7-6.8 14.8-21.8 14.8-21.8 12.5 2.4 14.2 2.4 5.3-1.4 8.7-2.5a20.16 20.16 0 015.6-1.1 20.16 20.16 0 015.6 1.1c3.4 1.1 7 2.5 8.7 2.5s14.2-2.4 14.2-2.4zM73.6 89.9c.9.6.4 1.7-.5 2.2S61 101.4 60 102.4s-2.7 2.5-3.8 2.5-2.7-1.6-3.8-2.5-12.3-9.7-13.1-10.3-1.4-1.7-.5-2.2 3.8-2 7.7-4.1 8.9-3.8 9.7-3.8 5.7 1.7 9.7 3.8 6.7 3.6 7.7 4.1z" }),
                    React__default.createElement("path", { fill: "url(#prefix__b)", d: "M87.9 13.1L76.4 0H35.9L24.4 13.1s-10.1-2.8-14.9 2c0 0 13.5-1.2 18.1 6.3 0 0 12.5 2.4 14.2 2.4s5.3-1.4 8.7-2.5a20.16 20.16 0 015.6-1.1 20.16 20.16 0 015.6 1.1c3.4 1.1 7 2.5 8.7 2.5s14.2-2.4 14.2-2.4c4.6-7.5 18.1-6.3 18.1-6.3-4.7-4.8-14.8-2-14.8-2" }))))));
}

function Chrome(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "aria-label": "Chrome", viewBox: "0 0 512 512" }, props),
        React__default.createElement("path", { d: "M256 140h228a256 256 0 01-240 371.7", fill: "#fc4" }),
        React__default.createElement("path", { d: "M357 314L244 511.7A256 256 0 0140 118", fill: "#0f9d58" }),
        React__default.createElement("path", { d: "M256 140h228a256 256 1 00-444-22l115 196", fill: "#db4437" }),
        React__default.createElement("circle", { cx: 256, cy: 256, r: 105, fill: "#4285f4", stroke: "#f1f1f1", strokeWidth: 24 })));
}

function Chromium(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "aria-label": "Chromium", viewBox: "0 0 512 512" }, props),
        React__default.createElement("path", { fill: "#a2c2fa", d: "M256 140h228a256 256 0 01-240 371.7" }),
        React__default.createElement("path", { fill: "#6199f6", d: "M357 314L244 511.7A256 256 0 0140 118" }),
        React__default.createElement("path", { fill: "#396bd7", d: "M256 140h228a256 256 1 00-444-22l115 196" }),
        React__default.createElement("circle", { cx: 256, cy: 256, r: 105, fill: "#4687f4", stroke: "#f1f1f1", strokeWidth: 24 })));
}

function Chrome$1(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "aria-label": "Edge", viewBox: "0 0 512 512" }, props),
        React__default.createElement("rect", { width: 512, height: 512, rx: "15%", fill: "#fff" }),
        React__default.createElement("radialGradient", { id: "prefix__a", cx: 0.6, cy: 0.5 },
            React__default.createElement("stop", { offset: 0.8, stopColor: "#148" }),
            React__default.createElement("stop", { offset: 1, stopColor: "#137" })),
        React__default.createElement("radialGradient", { id: "prefix__b", cx: 0.5, cy: 0.6, fx: 0.2, fy: 0.6 },
            React__default.createElement("stop", { offset: 0.8, stopColor: "#38c" }),
            React__default.createElement("stop", { offset: 1, stopColor: "#269" })),
        React__default.createElement("linearGradient", { id: "prefix__c", y1: 0.5, y2: 1 },
            React__default.createElement("stop", { offset: 0.1, stopColor: "#5ad" }),
            React__default.createElement("stop", { offset: 0.6, stopColor: "#5c8" }),
            React__default.createElement("stop", { offset: 0.8, stopColor: "#7d5" })),
        React__default.createElement("path", { d: "M439 374c-50 77-131 98-163 96-191-9-162-262-47-261-82 52 30 224 195 157 17-12 20 3 15 8", fill: "url(#prefix__a)" }),
        React__default.createElement("path", { d: "M311 255c18-82-31-135-129-135S38 212 38 259c0 124 125 253 287 203-134 39-214-116-146-210 46-66 123-68 132 3M411 99h1", fill: "url(#prefix__b)" }),
        React__default.createElement("path", { d: "M39 253C51-15 419-30 472 202c14 107-86 149-166 115-42-26 26-20-3-99-48-112-251-103-264 35", fill: "url(#prefix__c)" })));
}

function Firefox(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "aria-label": "Firefox", viewBox: "0 0 512 512" }, props),
        React__default.createElement("rect", { width: 512, height: 512, rx: "15%", fill: "#fff" }),
        React__default.createElement("linearGradient", { id: "prefix__a", x1: 0.7, x2: 0.3, y2: 0.8 },
            React__default.createElement("stop", { offset: 0.3, stopColor: "#fd5" }),
            React__default.createElement("stop", { offset: 0.6, stopColor: "#f85" }),
            React__default.createElement("stop", { offset: 1, stopColor: "#d06" })),
        React__default.createElement("radialGradient", { id: "prefix__b", cx: 0.4, cy: 0.7 },
            React__default.createElement("stop", { offset: 0.4, stopColor: "#74d" }),
            React__default.createElement("stop", { offset: 1, stopColor: "#a2d" })),
        React__default.createElement("linearGradient", { id: "prefix__c", x1: 0.8, y1: 0.2, x2: 0.4, y2: 0.8 },
            React__default.createElement("stop", { offset: 0.2, stopColor: "#fd5" }),
            React__default.createElement("stop", { offset: 1, stopColor: "#f33" })),
        React__default.createElement("g", { transform: "scale(4)" },
            React__default.createElement("path", { d: "M48 49s-3-9-1-16c-9 2-33 35-33 35a51 48 0 1087-32s5 9 5 15c-3-9-20-25-26-37-24 13-16 39-16 39", fill: "url(#prefix__a)" }),
            React__default.createElement("circle", { cx: 64, cy: 67, r: 26, fill: "url(#prefix__b)" }),
            React__default.createElement("path", { d: "M21 45l43 12c-6 11-16 3-23 14a22 22 0 1034-20s33 3 17 42H28m36 25h1", fill: "url(#prefix__a)" }),
            React__default.createElement("path", { d: "M35 43c16 0 12 7 29 14-18 6-23-9-38 0 5 9 12 8 12 8 1 43 72 29 67-17a50 46.6 47 01-88 33c-9-18-1-40 16-51", fill: "url(#prefix__c)" }))));
}

function Opera(_a) {
    var props = __rest(_a, []);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", "aria-label": "Opera", viewBox: "0 0 512 512" }, props),
        React__default.createElement("rect", { width: 512, height: 512, rx: "15%", fill: "#fff" }),
        React__default.createElement("path", { d: "M185.2 377.2c-23.7-28-39.1-69.6-40.2-116.1v-10.2c1-46.5 16.5-88 40.2-116 30.9-40.1 76.7-65.5 128-65.5 31.4 0 60.9 9.6 86 26.3A214.2 214.2 0 00256.9 41h-.8a215 215 0 10143.3 375.3 155.1 155.1 0 01-86.2 26.3c-51.2 0-97-25.4-127.9-65.4", fill: "#ff1b2d" }),
        React__default.createElement("path", { d: "M185.2 134.8c19.7-23.2 45.2-37.3 73-37.3 62.7 0 113.4 71 113.4 158.5s-50.7 158.5-113.3 158.5c-27.9 0-53.3-14-73-37.3 30.8 40 76.6 65.4 127.8 65.4 31.5 0 61-9.6 86.2-26.3 44-39.4 71.7-96.6 71.7-160.3 0-63.7-27.7-121-71.7-160.3A155.1 155.1 0 00313 69.4c-51.2 0-97 25.4-127.9 65.4", fill: "#a70014" })));
}

var ICONS = {
    brave: Brave,
    chrome: Chrome,
    chromium: Chromium,
    edge: Chrome$1,
    firefox: Firefox,
    opera: Opera,
};
function SandboxIcon(_a) {
    var sandboxType = _a.sandboxType, props = __rest(_a, ["sandboxType"]);
    var Icon = ICONS[sandboxType];
    return React__default.createElement(Icon, __assign({}, props));
}

/* eslint-disable @typescript-eslint/camelcase */
function applicationTypeTableLabel(t, application_type) {
    switch (application_type) {
        case 'mcafee_epo':
            return t('McAfee ePO');
        case 'wsus':
            return t('WSUS');
        default:
            return 'To be implemented';
    }
}
function applicationTypeFullLabel(t, application_type) {
    switch (application_type) {
        case 'mcafee_epo':
            return t('McAfee ePolicy Orchestrator');
        case 'wsus':
            return t('Windows Server Update Services');
        default:
            return 'To be implemented';
    }
}
function stringToApplicationType(application_type) {
    switch (application_type) {
        case 'mcafee_epo':
        case 'wsus':
            return application_type;
        default:
            return 'mcafee_epo';
    }
}
function applicationTypeSteps(t, application_type) {
    switch (application_type) {
        case 'mcafee_epo':
        case 'wsus':
            return [
                { label: t('Configure'), value: 'ap-configure' },
                { label: t('Connect'), value: 'ap-connection' },
                { label: t('Collectors'), value: 'ap-collectors' },
            ];
        default:
            return [];
    }
}
function applicationTypeTableIcon(application_type) {
    switch (application_type) {
        case 'mcafee_epo':
            return IconMcAfee;
        case 'wsus':
            return IconWindows;
        default:
            return IconMcAfee;
    }
}

/* eslint-disable @typescript-eslint/camelcase */
function computeTypeTableLabel(compute_type) {
    switch (compute_type) {
        case 'windows_agent':
            return 'Windows Asset - Agent';
        case 'windows_wmi':
            return 'Windows Asset - WMI';
        default:
            return 'To be implemented';
    }
}
function computeTypeTableUrl(compute_type) {
    switch (compute_type) {
        case 'windows_agent':
            return 'agent';
        case 'windows_wmi':
            return 'wmi';
        default:
            return '';
    }
}
function stringToComputeType(compute_type) {
    switch (compute_type) {
        case 'windows_agent':
            return 'windows_agent';
        case 'windows_wmi':
        default:
            return 'windows_wmi';
    }
}
function computeTypeSteps(compute_type) {
    switch (compute_type) {
        case 'windows_agent':
            return [
                { label: 'Configure', value: 'ca-agent-configure' },
                { label: 'Collectors', value: 'ca-agent-collectors' },
            ];
        case 'windows_wmi':
            return [
                { label: 'Configure', value: 'ca-wmi-configure' },
                { label: 'Connect', value: 'ca-wmi-connection' },
                { label: 'Collectors', value: 'ca-wmi-collectors' },
            ];
        default:
            return [];
    }
}
function computeTypeTableIcon(compute_type) {
    switch (compute_type) {
        case 'windows_agent':
        case 'windows_wmi':
            return faWindows;
        default:
            return faQuestionCircle;
    }
}

/* eslint-disable @typescript-eslint/camelcase */
function fieldTypeTableLabel(field_type) {
    switch (field_type) {
        case 'prm':
            return 'PRM';
        default:
            return 'To be implemented';
    }
}
function stringToFieldType(field_type) {
    switch (field_type) {
        case 'prm':
        default:
            return 'prm';
    }
}
function fieldTypeSteps(field_type) {
    switch (field_type) {
        case 'prm':
            return [
                { label: 'Configure', value: 'fa-prm-configure' },
                { label: 'Connect', value: 'fa-prm-connection' },
                // { label: 'Collectors', value: 'fa-prm-collectors' },
            ];
        default:
            return [];
    }
}

/* eslint-disable @typescript-eslint/camelcase */
function plcDcsTypeTableLabel(dsc_plc_type) {
    switch (dsc_plc_type) {
        case 'scs':
            return 'SCS';
        case 'fcs':
            return 'FCS';
        default:
            return 'To be implemented';
    }
}
function stringToPlcDcsType(dsc_plc_type) {
    switch (dsc_plc_type) {
        case 'fcs':
            return 'fcs';
        case 'scs':
        default:
            return 'scs';
    }
}
function plcDcsTypeSteps(dsc_plc_type) {
    switch (dsc_plc_type) {
        case 'fcs':
        case 'scs':
            return [
                { label: 'Configure', value: 'plc-prm-configure' },
                { label: 'Connect', value: 'plc-prm-connection' },
                { label: 'Collectors', value: 'plc-prm-collectors' },
            ];
        default:
            return [];
    }
}

/* eslint-disable @typescript-eslint/camelcase */
function networkTypeTableLabel(network_type) {
    switch (network_type) {
        case 'switch':
            return 'Switch';
        case 'router':
            return 'Router';
        case 'firewall':
            return 'Firewall';
        case 'timeserver':
            return 'Time Server';
        default:
            return 'To be implemented';
    }
}
function stringToNetworkType(network_type) {
    switch (network_type) {
        case 'switch':
        case 'router':
        case 'firewall':
        case 'timeserver':
            return network_type;
        default:
            return 'switch';
    }
}
function networkTypeSteps(network_type) {
    switch (network_type) {
        case 'switch':
        case 'firewall':
        case 'router':
        case 'timeserver':
            return [
                { label: 'Configure', value: 'na-configure' },
                { label: 'Connect', value: 'na-connection' },
                { label: 'Collectors', value: 'na-collectors' },
                { label: 'Setup', value: 'na-setup-logs' },
            ];
        default:
            return [];
    }
}
function networkTypeTableIcon(network_type) {
    switch (network_type) {
        case 'switch':
            return faEthernet;
        case 'firewall':
            return faFire;
        case 'router':
            return faNetworkWired;
        case 'timeserver':
            return faClock;
        default:
            return faQuestionCircle;
    }
}

function removeSearchParam(param, refresh) {
    if (refresh === void 0) { refresh = false; }
    /**
     * Remove `param` from query parameters and return new url.
     * - if no parameters exist, return original url
     * - `refresh`=undefined -> only return url.
     * - `refresh`=false -> update browser window location without refresh.
     * - `refresh`=true -> update browser window location with refresh.
     */
    var href = window.location.href;
    var paramIndex = href.indexOf('?');
    var cleanUrl;
    if (paramIndex >= 0) {
        var location_1 = href.slice(0, href.indexOf('?'));
        var params = new URLSearchParams(href.slice(href.indexOf('?') + 1));
        params.delete(param);
        var hasParams = params.toString().length > 0;
        cleanUrl = hasParams ? [location_1, params.toString()].join('?') : location_1;
    }
    else {
        cleanUrl = href;
    }
    if (refresh === true)
        window.location.href = cleanUrl;
    else if (refresh === false)
        window.history.replaceState(null, document.title, cleanUrl);
    return cleanUrl;
}

function getAuthToken() {
    /**
     * Get current openid 'Bearer' token from sessionStorage
     */
    return sessionStorage.getItem('token');
}
function getAuthHeader() {
    /**
     * Get current auth header object.
     *
     * eg. {Authorization: Bearer <token>}
     */
    return { Authorization: "Bearer ".concat(getAuthToken()) };
}
function getSiteHeader(site) {
    /**
     * Get current auth header object.
     *
     * eg. {Authorization: Bearer <token>}
     */
    return site ? { 'X-Site-Id': site.id } : undefined;
}
var defaultParams = function () { return ({
    headers: __assign({ 'Content-Type': 'application/json' }, getAuthHeader()),
}); };
var _fetch = function (input, init) {
    var params = init || { headers: {} };
    return fetch(input, __assign(__assign(__assign({}, defaultParams()), params), { headers: __assign(__assign({}, defaultParams().headers), params === null || params === void 0 ? void 0 : params.headers) }));
};
var _fetchSite = function (input, init, site) {
    init = __assign(__assign({}, init), { headers: __assign(__assign({}, getSiteHeader(site)), init === null || init === void 0 ? void 0 : init.headers) });
    return _fetch(input, init);
};
var Fetch = function (site) { return ({
    get: function (input, init) {
        return _fetchSite(input, __assign(__assign({}, init), { method: 'GET' }), site);
    },
    post: function (input, init) {
        return _fetchSite(input, __assign(__assign({}, init), { method: 'POST' }), site);
    },
    patch: function (input, init) {
        return _fetchSite(input, __assign(__assign({}, init), { method: 'PATCH' }), site);
    },
    put: function (input, init) {
        return _fetchSite(input, __assign(__assign({}, init), { method: 'PUT' }));
    },
    delete: function (input, init) {
        return _fetchSite(input, __assign(__assign({}, init), { method: 'DELETE' }), site);
    },
}); };

/**
 * Uppy hook.
 *
 * Before every request the current openid auth token is set in the headers.
 *
 */
function useUppy(_a) {
    var factory = _a.factory, site = _a.site;
    function tusfactory(uppy) {
        return uppy
            .use(Tus, {
            endpoint: '/api/file-transfer/upload/',
            chunkSize: 1023 * 1024 * 4,
            removeFingerprintOnSuccess: true,
            limit: 1,
            retryDelays: [
                0,
                1000,
                1000,
                1000,
                1000,
                2000,
                2000,
                2000,
                2000,
                2000,
                2000,
                5000,
                5000,
                5000,
                8000,
                8000,
                13000,
                21000,
                34000,
                55000,
            ],
            headers: __assign({}, getSiteHeader(site)),
            onBeforeRequest: function (req) {
                var _a;
                req.setHeader('Authorization', (_a = getAuthHeader()) === null || _a === void 0 ? void 0 : _a.Authorization);
            },
        })
            .use(DropTarget, { target: document.body })
            .on('file-added', function (file) {
            uppy.setFileMeta(file.id, { fingerprint: file.id });
        })
            .on('back-online', function () {
            console.log('BACK ONLINE!');
            uppy.retryAll();
        });
    }
    var uppyRef = useRef$1(undefined);
    // Make sure we only initialize it the first time:
    if (uppyRef.current === undefined) {
        uppyRef.current = tusfactory(factory());
    }
    /**
     * Cleanup handler
     */
    useEffect$1(function () {
        if (uppyRef.current !== undefined) {
            return function () {
                // console.log('Close uppy instance');
                uppyRef.current && uppyRef.current.close();
            };
        }
    }, []);
    return uppyRef.current;
}

var Page = function (_a) {
    var main = _a.main, sidebar = _a.sidebar, actions = _a.actions, _b = _a.card, card = _b === void 0 ? true : _b, _c = _a.padding, padding = _c === void 0 ? true : _c, cardClassNames = _a.cardClassNames, loading = _a.loading, breadCrumbs = _a.breadCrumbs;
    if (loading)
        return React__default.createElement(Loading, null);
    return (React__default.createElement(Grid.Container, null,
        React__default.createElement(Grid.Row, null,
            React__default.createElement("div", { className: "page-header ".concat(sidebar ? 'col-10' : 'col') },
                React__default.createElement("div", { className: "page-title" }, breadCrumbs),
                React__default.createElement("div", { className: "actions" }, actions))),
        React__default.createElement(Grid.Row, null,
            React__default.createElement(Grid.Col, { width: sidebar ? 10 : undefined }, card ? (React__default.createElement(Card, { className: cardClassNames, bodyStyle: { padding: padding ? '1.25rem' : 0 } }, main)) : (React__default.createElement(React__default.Fragment, null, main))),
            sidebar && React__default.createElement(Grid.Col, { width: 2 }, sidebar))));
};

var PageContent = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, actions = _a.actions, children = _a.children, className = _a.className;
    var classes = cn({
        'd-flex justify-content-between border-bottom border-light mb-4 pb-3': (title && typeof title === 'string') || subtitle,
    });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "".concat(classes, " ").concat(String(className)) },
            React__default.createElement("div", null,
                title && typeof title === 'string' ? (React__default.createElement("h4", { className: "" }, title)) : (React__default.createElement(React__default.Fragment, null, title)),
                subtitle && React__default.createElement("span", { className: "text-sm text-muted" }, subtitle)),
            actions && actions),
        children));
};

var Container$3 = styled.footer(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  padding: 1rem 0;\n  background: ", ";\n"], ["\n  padding: 1rem 0;\n  background: ", ";\n"])), function (p) { return p.theme.colors.common.grey200; });
function Footer(_a) {
    var t = _a.t;
    var currentYear = new Date().getFullYear();
    return (React__default.createElement(Container$3, null,
        React__default.createElement(Grid.Container, null,
            React__default.createElement(Flex, { h: "between", v: "center" },
                React__default.createElement("div", null,
                    React__default.createElement("small", null,
                        t('breadcrumbs:Copyright'),
                        " \u00A9 ",
                        currentYear,
                        ' ',
                        t('breadcrumbs:Yokogawa Electric Corporation'),
                        ".",
                        ' ',
                        t('breadcrumbs:All rights reserved'),
                        ".")),
                React__default.createElement("div", null,
                    React__default.createElement(Link, { to: "/release-notes" }, t('breadcrumbs:Release Notes')))))));
}
var templateObject_1$8;

var text = {
    heading: 'Terms & Conditions',
    acceptText: "I've read the terms & conditions",
    acceptButton: 'Accept',
    declineButton: 'Decline',
};
var Backdrop = styled.div(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 9999;\n  height: 100vh;\n  width: 100vw;\n  background: #F7F7F7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 9999;\n  height: 100vh;\n  width: 100vw;\n  background: #F7F7F7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var showHeader = _a.showHeader;
    return showHeader && css(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n      top: 3.5rem;\n      height: calc(100vh - 3.5rem);\n    "], ["\n      top: 3.5rem;\n      height: calc(100vh - 3.5rem);\n    "])));
}, function (_a) {
    var showFooter = _a.showFooter;
    return showFooter && css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n      bottom: 50px;\n      height: calc(100vh - 50px);\n    "], ["\n      bottom: 50px;\n      height: calc(100vh - 50px);\n    "])));
}, function (p) {
    return p.showHeader &&
        p.showFooter && css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n      height: calc(100vh - 3.5rem - 50px);\n    "], ["\n      height: calc(100vh - 3.5rem - 50px);\n    "])));
});
var ModalContainer = styled.div(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  width: 100vw;\n  margin: 0.5rem;\n  pointer-events: none;\n\n  @media (min-width: 800px) {\n    max-width: 800px;\n    margin: 1.75rem auto;\n  }\n"], ["\n  width: 100vw;\n  margin: 0.5rem;\n  pointer-events: none;\n\n  @media (min-width: 800px) {\n    max-width: 800px;\n    margin: 1.75rem auto;\n  }\n"])));
var Modal = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-radius: 3px;\n  outline: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.09);\n  border-radius: 3px;\n  outline: 0;\n"])));
var StaticModal = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React__default.createElement(Backdrop, __assign({}, rest),
        React__default.createElement(ModalContainer, null,
            React__default.createElement(Modal, null, children))));
};
var ModalHeader = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border: none;\n  padding: 32px;\n  padding-bottom: 24px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  line-height: 1.375;\n  font-size: 1.5rem;\n  font-weight: 500;\n"], ["\n  border: none;\n  padding: 32px;\n  padding-bottom: 24px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  line-height: 1.375;\n  font-size: 1.5rem;\n  font-weight: 500;\n"])));
var ModalBody = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 0 32px;\n  position: relative;\n"], ["\n  padding: 0 32px;\n  position: relative;\n"])));
var BodyBlock = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: min-height ease 0.2s;\n  min-height: 100px;\n\n  @media (min-width: 576px) {\n    min-height: 150px;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: min-height ease 0.2s;\n  min-height: 100px;\n\n  @media (min-width: 576px) {\n    min-height: 150px;\n  }\n\n  ", "\n"])), function (p) {
    return p.hasContent
        ? css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          min-height: 0px !important;\n          align-items: flex-start;\n\n          justify-content: flex-start;\n        "], ["\n          min-height: 0px !important;\n          align-items: flex-start;\n\n          justify-content: flex-start;\n        "]))) : null;
});
var ModalFooter = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  padding: 16px 32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"], ["\n  padding: 16px 32px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var Label = styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-weight: 600;\n  cursor: pointer;\n  margin-left: 8px;\n"], ["\n  font-weight: 600;\n  cursor: pointer;\n  margin-left: 8px;\n"])));
var SwitchContainer = styled(Flex)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  margin: 1rem 0;\n"], ["\n  margin: 1rem 0;\n"])));
var KeycloakButton = styled.button(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  margin-top: 0;\n  padding: 0.375rem 0.75rem;\n  line-height: 2.25;\n  border-radius: 3px;\n  transition: 0.2s ease;\n  min-width: 200px;\n  font-size: 14px;\n\n  ", "\n\n  ", "\n\n&:disabled {\n    filter: saturate(0.6);\n    opacity: 0.4;\n    cursor: default;\n  }\n"], ["\n  margin-top: 0;\n  padding: 0.375rem 0.75rem;\n  line-height: 2.25;\n  border-radius: 3px;\n  transition: 0.2s ease;\n  min-width: 200px;\n  font-size: 14px;\n\n  ", "\n\n  ", "\n\n&:disabled {\n    filter: saturate(0.6);\n    opacity: 0.4;\n    cursor: default;\n  }\n"])), function (p) {
    return p.color === 'primary' && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      color: white;\n      background: ", ";\n      border: 2px solid\n        ", ";\n\n      &:not(:disabled):hover {\n        background: ", ";\n        border: 2px solid\n          ", ";\n      }\n    "], ["\n      color: white;\n      background: ", ";\n      border: 2px solid\n        ", ";\n\n      &:not(:disabled):hover {\n        background: ", ";\n        border: 2px solid\n          ", ";\n      }\n    "])), function (p) {
        return p.theme.colors[p.variant].primary.main;
    }, function (p) { return p.theme.colors[p.variant].primary.main; }, function (p) {
        return p.theme.colors[p.variant].primary.dark;
    }, function (p) { return p.theme.colors[p.variant].primary.dark; });
}, function (p) {
    return p.color === 'grey' && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      color: rgba(0, 0, 0, 0.67);\n      background: white;\n      border: 2px solid transparent;\n\n      &:not(:disabled):hover {\n        background: #f7f7f7;\n        border: 2px solid #f7f7f7;\n      }\n    "], ["\n      color: rgba(0, 0, 0, 0.67);\n      background: white;\n      border: 2px solid transparent;\n\n      &:not(:disabled):hover {\n        background: #f7f7f7;\n        border: 2px solid #f7f7f7;\n      }\n    "])));
});
var TermsConditions = function (_a) {
    var _b = _a.termsUrl, termsUrl = _b === void 0 ? '/api/center/terms.html/' : _b, logout = _a.logout, _c = _a.variant, variant = _c === void 0 ? 'site' : _c;
    var url = useRouteMatch().url;
    var _d = __read(useState(false), 2), readTerms = _d[0], setReadTerms = _d[1];
    var _e = __read(useState(null), 2), acceptedTerms = _e[0], setAcceptedTerms = _e[1];
    var _f = __read(useFetch({ url: termsUrl, type: 'html' }), 1), terms = _f[0];
    var _g = __read(useFetch({
        url: '/api/me/terms/',
        initialFetch: false,
        options: { method: 'POST' },
        body: { agree: acceptedTerms },
    }), 2), postTerms = _g[1];
    var effectPostTerms = function (accepted) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, postTerms()];
                case 1:
                    _a.sent();
                    if (accepted)
                        window.location.href = url;
                    if (!accepted)
                        logout();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect$1(function () {
        if (acceptedTerms === true || acceptedTerms === false)
            effectPostTerms(acceptedTerms);
    }, [acceptedTerms]);
    var acceptTerms = function () {
        setAcceptedTerms(true);
    };
    var declineTerms = function () {
        setAcceptedTerms(false);
    };
    var toggleReadTerms = function () { return setReadTerms(!readTerms); };
    return (React__default.createElement(StaticModal, null,
        React__default.createElement(ModalHeader, null, text.heading),
        React__default.createElement(ModalBody, null,
            React__default.createElement(BodyBlock, { hasContent: Boolean(terms.data) },
                terms.data && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("span", { dangerouslySetInnerHTML: { __html: terms.data } }),
                    React__default.createElement(SwitchContainer, { v: "center" },
                        React__default.createElement(Switch$1, { size: "small", checked: readTerms, onChange: toggleReadTerms }),
                        React__default.createElement(Label, { onClick: toggleReadTerms }, text.acceptText)))),
                !terms.data && React__default.createElement(Loading, null))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(KeycloakButton, { color: "grey", disabled: !terms.data, onClick: declineTerms, variant: variant }, text.declineButton),
            React__default.createElement(KeycloakButton, { disabled: !readTerms, color: "primary", variant: variant, onClick: acceptTerms }, text.acceptButton))));
};
var templateObject_1$9, templateObject_2$2, templateObject_3$2, templateObject_4$1, templateObject_5$1, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;

var BlinkIcon = styled(FontAwesomeIcon)(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  &.blink {\n    animation: blink 2.2s ease infinite;\n  }\n\n  @keyframes blink {\n    0% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 0px transparent);\n    }\n    10% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 3px ", ");\n    }\n    80% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 3px ", ");\n    }\n    100% {\n      color: ", ";\n      filter: drop-shadow(0px 0px px transparent);\n    }\n  }\n"], ["\n  &.blink {\n    animation: blink 2.2s ease infinite;\n  }\n\n  @keyframes blink {\n    0% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 0px transparent);\n    }\n    10% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 3px ", ");\n    }\n    80% {\n      color: ", ";\n      filter: drop-shadow(0px 0px 3px ", ");\n    }\n    100% {\n      color: ", ";\n      filter: drop-shadow(0px 0px px transparent);\n    }\n  }\n"])), theme.colors.common.gray300, function (p) { return p.color; }, function (p) { return p.color; }, function (p) { return p.color; }, function (p) { return p.color; }, theme.colors.common.gray300);
function StatusIndicator(_a) {
    var variant = _a.variant, label = _a.label, _b = _a.blink, blink = _b === void 0 ? false : _b;
    var color = function () {
        switch (variant) {
            case 'green':
                return theme.colors.common.green;
            case 'red':
                return theme.colors.common.red;
            case 'yellow':
                return theme.colors.common.yellow;
            case 'grey':
            default:
                return theme.colors.common.gray300;
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(BlinkIcon, { icon: faCircle, color: color(), size: "1x", style: { marginRight: 4 }, className: blink ? 'blink' : '' }),
        label));
}
var templateObject_1$a;

var GUACAMOLE_CLIENT_STATES = {
    STATE_IDLE: 0,
    STATE_CONNECTING: 1,
    STATE_WAITING: 2,
    STATE_CONNECTED: 3,
    STATE_DISCONNECTING: 4,
    STATE_DISCONNECTED: 5,
};
var GUACAMOLE_STATUS = {
    0: {
        name: 'SUCCESS',
        text: 'The operation succeeded. No error.',
    },
    256: {
        name: 'UNSUPPORTED',
        text: 'The requested operation is unsupported.',
    },
    512: {
        name: 'SERVER_ERROR',
        text: 'An internal error occurred, and the operation could not be performed.',
    },
    513: {
        name: 'SERVER_BUSY',
        text: 'The operation could not be performed because the server is busy.',
    },
    514: {
        name: 'UPSTREAM_TIMEOUT',
        text: 'The upstream server is not responding. In most cases, the upstream server is the remote desktop server.',
    },
    515: {
        name: 'UPSTREAM_ERROR',
        text: 'The upstream server encountered an error. In most cases, the upstream server is the remote desktop server.',
    },
    516: {
        name: 'RESOURCE_NOT_FOUND',
        text: 'An associated resource, such as a file or stream, could not be found, and thus the operation failed.',
    },
    517: {
        name: 'RESOURCE_CONFLICT',
        text: 'A resource is already in use or locked, preventing the requested operation.',
    },
    518: {
        name: 'RESOURCE_CLOSED',
        text: 'The requested operation cannot continue because the associated resource has been closed.',
    },
    519: {
        name: 'UPSTREAM_NOT_FOUND',
        text: 'The upstream server does not appear to exist, or cannot be reached over the network. In most cases, the upstream server is the remote desktop server.',
    },
    520: {
        name: 'UPSTREAM_UNAVAILABLE',
        text: 'The upstream server is refusing to service connections. In most cases, the upstream server is the remote desktop server.',
    },
    521: {
        name: 'SESSION_CONFLICT',
        text: 'The session within the upstream server has ended because it conflicts with another session. In most cases, the upstream server is the remote desktop server.',
    },
    522: {
        name: 'SESSION_TIMEOUT',
        text: 'The session within the upstream server has ended because it appeared to be inactive. In most cases, the upstream server is the remote desktop server.',
    },
    523: {
        name: 'SESSION_CLOSED',
        text: 'The session within the upstream server has been forcibly closed. In most cases, the upstream server is the remote desktop server.',
    },
    768: {
        name: 'CLIENT_BAD_REQUEST',
        text: 'The parameters of the request are illegal or otherwise invalid.',
    },
    769: {
        name: 'CLIENT_UNAUTHORIZED',
        text: 'Permission was denied, because the user is not logged in. Note that the user may be logged into Guacamole, but still not logged in with respect to the remote desktop server.',
    },
    771: {
        name: 'CLIENT_FORBIDDEN',
        text: 'Permission was denied, and logging in will not solve the problem.',
    },
    776: {
        name: 'CLIENT_TIMEOUT',
        text: 'The client (usually the user of Guacamole or their browser) is taking too long to respond.',
    },
    781: {
        name: 'CLIENT_OVERRUN',
        text: 'The client has sent more data than the protocol allows.',
    },
    783: {
        name: 'CLIENT_BAD_TYPE',
        text: 'The client has sent data of an unexpected or illegal type.',
    },
    797: {
        name: 'CLIENT_TOO_MANY',
        text: 'The client is already using too many resources. Existing resources must be freed before further requests are allowed.',
    },
};

var Popover = styled(Popover$1)(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  .ant-popover {\n    * {\n      animation-duration: 0s !important;\n      transform: 0;\n    }\n    width: 300px;\n  }\n  .ant-popover-title {\n    padding-right: 0;\n  }\n  .ant-popover-inner-content {\n    padding: 0;\n    textarea {\n      width: 300px;\n      min-height: 200px;\n    }\n  }\n  .title {\n    line-height: 32px;\n  }\n"], ["\n  .ant-popover {\n    * {\n      animation-duration: 0s !important;\n      transform: 0;\n    }\n    width: 300px;\n  }\n  .ant-popover-title {\n    padding-right: 0;\n  }\n  .ant-popover-inner-content {\n    padding: 0;\n    textarea {\n      width: 300px;\n      min-height: 200px;\n    }\n  }\n  .title {\n    line-height: 32px;\n  }\n"])));
function ClipboardMenu(_a) {
    var clipboardValue = _a.clipboardValue, onClipboardChanged = _a.onClipboardChanged;
    var _b = __read(useTranslation(['common', 'remoteAccess']), 1), t = _b[0];
    var _c = __read(useState(false), 2), visible = _c[0], setVisible = _c[1];
    var _d = __read(useState(clipboardValue), 2), value = _d[0], setValue = _d[1];
    useEffect$1(function () {
        if (clipboardValue === value)
            return;
        setValue(clipboardValue);
    }, [clipboardValue]);
    var visibleChange = function (x) {
        console.log('visibleChange!', x);
        if (!x && value !== clipboardValue) {
            onClipboardChanged(value);
        }
        setVisible(x);
    };
    return (React__default.createElement(Popover
    // overlayStyle={{ width: '300px' }}
    , { 
        // overlayStyle={{ width: '300px' }}
        content: React__default.createElement(TextArea, { onChange: function (x) {
                setValue(x.target.value);
                onClipboardChanged(x.target.value);
            }, value: value }), title: React__default.createElement(Flex, { h: 'between' },
            React__default.createElement("div", { className: 'title' }, t('Clipboard')),
            React__default.createElement(Button$1, { type: "link", onClick: function () { return setVisible(false); } },
                React__default.createElement(X, { size: 16 }))), trigger: "click", visible: visible, overlayStyle: {
            width: '300px',
        }, placement: 'bottomRight', onVisibleChange: visibleChange, getPopupContainer: function (container) { return container; }, arrowPointAtCenter: true, autoAdjustOverflow: false },
        React__default.createElement("span", null,
            React__default.createElement(Button$1, { ghost: false, style: {
                    borderColor: '#fff',
                    backgroundColor: 'transparent',
                    position: 'relative',
                } },
                React__default.createElement(Clipboard, { style: { stroke: '#fff' }, size: 16 })))));
}
var templateObject_1$b;

var podCondition = function (pod) {
    var _a, _b, _c, _d;
    var status = pod.status;
    var condition = ((_a = pod.container_status) === null || _a === void 0 ? void 0 : _a.status) || null;
    if (pod.condition)
        status = pod.condition;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("pre", null,
            status.toLowerCase(),
            condition ? " | ".concat(condition) : ""),
        ((_c = (_b = pod.container_status) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) ? (React__default.createElement(Alert, { message: pod.container_status.data.message, description: (_d = pod.container_status.data) === null || _d === void 0 ? void 0 : _d.reason, type: "warning", style: { width: '37%' } })) : null));
};
function SandboxLoader(_a) {
    var pod = _a.pod, sandboxType = _a.sandboxType;
    var _b = __read(useTranslation(['common', 'remoteAccess']), 1), t = _b[0];
    return (React__default.createElement(Flex, { v: 'center', h: 'center', column: true, style: { height: '100vh' } },
        React__default.createElement("h2", null, t('Loading Web Browser')),
        React__default.createElement(SandboxIcon, { sandboxType: sandboxType, width: 250, height: 250 }),
        React__default.createElement("h3", null,
            t('Creating sandbox environment'),
            " ",
            React__default.createElement(Loading, null)),
        podCondition(pod)));
}

function FileTransferMenu(_a) {
    var _this = this;
    var api = _a.api;
    var _b = __read(useTranslation(['common', 'remoteAccess']), 1), t = _b[0];
    // const [loading, setLoading] = useState<boolean>(false);
    var sandboxExec = function (action) { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.exec(action)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('Error executing action in sandbox', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement("span", null,
        React__default.createElement(Button$1, { ghost: false, style: {
                borderColor: '#fff',
                backgroundColor: 'transparent',
                position: 'relative',
            }, onClick: function () { return sandboxExec('site-tab-filetransfer'); } },
            React__default.createElement(File, { style: { stroke: '#fff' }, size: 16, xlinkTitle: t('FileTransfer') }))));
}

var SandboxApi = function (sessionId, site) { return ({
    appContext: site ? 'center' : 'site',
    isCenter: !!site,
    isSite: !site,
    exec: function (action, params) { return __awaiter(void 0, void 0, void 0, function () {
        var body, result, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = JSON.stringify({
                        action: action,
                        params: params,
                        refresh: sessionStorage.getItem('refresh-token'),
                    });
                    return [4 /*yield*/, Fetch(site).post("/api/remote-session/".concat(sessionId, "/sandbox_exec/"), { body: body })];
                case 1:
                    result = _a.sent();
                    if (result.status >= 400)
                        throw Error(result.statusText);
                    return [4 /*yield*/, result.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    }); },
}); };

var SubTitle = styled.span(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  font-weight: 300;\n  text-transform: uppercase;\n  margin: 0;\n  margin-left: 0.75rem;\n  font-size: 1.25rem;\n"], ["\n  font-weight: 300;\n  text-transform: uppercase;\n  margin: 0;\n  margin-left: 0.75rem;\n  font-size: 1.25rem;\n"])));
var IconButton = styled(Button$1)(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  text-align: center;\n  display: inline;\n  background-color: transparent;\n  border: none;\n"], ["\n  text-align: center;\n  display: inline;\n  background-color: transparent;\n  border: none;\n"])));
var getSite = function (siteId) {
    return siteId ? { id: siteId, name: '', timezone: '' } : undefined;
};
var stateLabel = function (s) {
    switch (s) {
        case 0:
            return 'Idle';
        case 1:
            return 'Connecting';
        case 2:
            return 'Waiting';
        case 3:
            return 'Connected';
        case 4:
            return 'Disconnecting';
        case 5:
            return 'Disconnected';
    }
};
var Brand = function (_a) {
    var logo = _a.logo, subtitle = _a.subtitle;
    return (React__default.createElement(Flex, { v: "center" },
        React__default.createElement(Link, { to: "/" }, logo),
        React__default.createElement(SubTitle, null, subtitle)));
};
var sendClipboard = function (client, value) {
    var stream = client.createClipboardStream('text/plain'
    // 'clipboard'
    );
    setTimeout(function () {
        // remove '\r', because on pasting it becomes two new lines (\r\n -> \n\n)
        stream === null || stream === void 0 ? void 0 : stream.sendBlob(btoa(unescape(encodeURIComponent(value))));
        stream === null || stream === void 0 ? void 0 : stream.sendEnd();
    }, 200);
};
function RemoteClient(_a) {
    var _b, _c;
    var component = _a.component, siteId = _a.siteId, readonly = _a.readonly, containerWidth = _a.containerWidth;
    var _d = __read(useTranslation(['common', 'remoteAccess']), 1), t = _d[0];
    var _e = __read(useState([0, 0]), 2), _f = __read(_e[0], 2), width = _f[0], height = _f[1], setDimensions = _e[1];
    var _g = __read(useState(false), 2), authCookieReady = _g[0], setAuthCookieReady = _g[1];
    var _h = __read(useState(false), 2), sandboxLoading = _h[0], setSandboxLoading = _h[1];
    var _j = __read(useState(getSite(siteId)), 2), site = _j[0], setSite = _j[1];
    var _k = __read(useState(), 2), sandboxApi = _k[0], setSandboxApi = _k[1];
    var _l = __read(useState(null), 2), terminate = _l[0], setTerminate = _l[1];
    var _m = __read(useState({
        name: '',
        status: 'Pending',
        condition: '',
        container_status: {
            status: '',
        },
        ready: false,
    }), 2), sandboxStatus = _m[0], setSandboxStatus = _m[1];
    var isInitialStatus = sandboxStatus.name === '';
    var _o = __read(useState(''), 2), clipboardValue = _o[0], setClipboardValue = _o[1];
    var _p = __read(useState(GUACAMOLE_CLIENT_STATES.STATE_IDLE), 2), state = _p[0], setState = _p[1];
    var displayRef = useRef$1(null);
    var downloadLink = useRef$1(null);
    var sessionId = useParams().sessionId;
    var guacRef = useRef$1(null);
    var connectParamsRef = useRef$1({});
    var scale = useRef$1(1);
    var typedComponent = component;
    useEffect$1(function () {
        var site = getSite(siteId);
        setSite(site);
        setSandboxApi(SandboxApi(sessionId, site));
    }, [sessionId, siteId]);
    var getConnectionString = useCallback(function () {
        var wsScheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
        var host = window.location.host;
        var wsPath = wsScheme + '://' + host + '/ws/remote-session/' + sessionId + '/';
        var params = connectParamsRef.current;
        if (siteId)
            params['site_id'] = siteId;
        var newParams = Object.keys(params)
            .map(function (key) {
            if (Array.isArray(params[key])) {
                return params[key]
                    .map(function (item) {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(item);
                })
                    .join('&');
            }
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        })
            .join('&');
        var url = new URL(wsPath);
        return { url: url.href, params: newParams };
    }, [sessionId]);
    // get remote session object
    var _q = __read(useFetch({
        options: __assign({ method: 'POST' }, (component === 'center' && {
            headers: {
                'X-Site-Id': siteId || '',
            },
        })),
        url: "/api/remote-session/".concat(sessionId, "/sandbox/?verbose=").concat(isInitialStatus),
        defaultValue: {},
        initialFetch: false,
        onSucces: function (data) {
            var _a;
            setSandboxStatus(__assign({}, (_a = data.data) === null || _a === void 0 ? void 0 : _a.pod));
            if (data.data.pod.ready) {
                setTimeout(function () {
                    setAuthCookieReady(true);
                    setSandboxLoading(false);
                }, 2000);
            }
            else {
                setTimeout(function () {
                    fetchSandbox();
                }, 1500);
            }
        },
        onFail: function (_a) {
            var error = _a.error;
            var msg = '';
            if (error === 412) {
                msg = t('The maximum amount of concurrent WEB remote sessions is reached.');
                // quota exceeded
                openNotificationWithIcon(notification.error, t('Sandbox quota exceeded'), React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("p", { className: "mt-2" }, msg),
                    React__default.createElement("p", null, t('Please try again later.'))));
            }
            else {
                msg = t('Error while trying to run sandbox.');
                openNotificationWithIcon(notification.error, t('Sandbox failure'), msg);
            }
            setTerminate(msg);
        },
    }), 2), fetchSandbox = _q[1];
    // get remote session object
    var _r = __read(useFetch({
        options: component === 'center'
            ? {
                headers: {
                    'X-Site-Id': siteId || '',
                },
            }
            : {},
        url: "/api/remote-session/".concat(sessionId, "/?auth_cookie"),
        defaultValue: {},
        onSucces: function (data) {
            if (data.data.protocol === 'web') {
                setSandboxLoading('firefox');
                fetchSandbox();
            }
            else {
                setAuthCookieReady(true);
            }
        },
        onFail: function () {
            openNotificationWithIcon(notification.error, t('Failed to get session details'), t('We could not retrieve the data for this session. Please try again later.'));
        },
    }), 1), fetchedSession = _r[0];
    // Focuses Guacamole Client Display element if it's parent element has been clicked,
    // because div with GuacamoleClient inside otherwise does not focus.
    var parentOnClickHandler = function () {
        if (displayRef.current)
            displayRef.current.focus();
    };
    // updates scale factor given new actual display width/height
    var rescaleDisplay = useCallback(function () {
        var _a, _b, _c;
        if (!guacRef.current || readonly)
            return;
        // get current width/height of connection
        var remoteDisplayWidth = (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.getDisplay().getWidth();
        var remoteDisplayHeight = (_b = guacRef.current) === null || _b === void 0 ? void 0 : _b.getDisplay().getHeight();
        if (!displayRef.current) {
            return;
        }
        var newWidth = displayRef.current.clientWidth;
        var newHeight = displayRef.current.clientHeight;
        // calculate which scale should we use - width or height, in order to see all of remote display
        var newScale = Math.min(newWidth / remoteDisplayWidth, newHeight / remoteDisplayHeight, 1);
        (_c = guacRef.current) === null || _c === void 0 ? void 0 : _c.getDisplay().scale(newScale);
        scale.current = newScale;
    }, []);
    // Display size update handler, currently implement onli logging to console
    var updateDisplaySize = useCallback(function (width, height) {
        if (!guacRef.current)
            return;
        // save new width/height for reconnect purposes
        connectParamsRef.current.width = width;
        connectParamsRef.current.height = height;
        if (width === 0 || height === 0) {
            console.warn('Not sending this dimentions!!', { width: width, height: height });
            return;
        }
        if (!readonly)
            guacRef.current.sendSize(width, height);
    }, [rescaleDisplay]);
    // Main effect which constructs GuacamoleClient
    // should reaaaly be run only once
    useEffect$1(function () {
        var _a, _b, _c, _d;
        if (!authCookieReady) {
            // sessionData not fetched, auth_cookie not set, yet
            return;
        }
        if (sandboxLoading) {
            // waiting for sandbox to be initialized
            return;
        }
        // Determine websocket URI
        var url = getConnectionString().url;
        var tunnel = new Guacamole.WebSocketTunnel(url);
        guacRef.current = new Guacamole.Client(tunnel);
        guacRef.current.onaudio = function clientAudio(stream, mimetype) {
            var context = Guacamole.AudioContextFactory.getAudioContext();
            context.resume();
            var player = Guacamole.AudioPlayer.getInstance(stream, mimetype);
            return player;
        };
        guacRef.current.onstatechange = function (newState) {
            if (guacRef.current === null)
                return;
            setState(newState);
            switch (newState) {
                case 3:
                    guacRef.current.onclipboard = function (stream, mimetype) {
                        // don't do anything if this is not active element
                        // if (document.activeElement !== displayRef.current || readonly) return;
                        var reader;
                        if (/^text\//.exec(mimetype)) {
                            reader = new Guacamole.StringReader(stream);
                            // Assemble received data into a single string
                            var data_1 = '';
                            reader.ontext = function textReceived(text) {
                                data_1 += text;
                            };
                            // Set clipboard contents once stream is finished
                            reader.onend = function () {
                                if (data_1.trim() !== '') {
                                    // put data received form server to client's clipboard
                                    navigator.clipboard.writeText(data_1);
                                    setClipboardValue(data_1);
                                }
                            };
                        }
                    };
                    break;
            }
        };
        guacRef.current.onerror = function (error) {
            var msg = error.message;
            // if (GUACAMOLE_STATUS[error.code]) {
            //   msg = (
            //     <p>
            //       {error.message}
            //       <br />
            //       {GUACAMOLE_STATUS[error.code].name}
            //       <br />
            //       {GUACAMOLE_STATUS[error.code].text}
            //     </p>
            //   );
            // }
            openNotificationWithIcon(notification.error, t('Error'), msg);
        };
        tunnel.onerror = function (error) {
            console.error('TUNNEL ERROR', error);
            var msg = React__default.createElement("p", null, "Connection handshake failed");
            if (GUACAMOLE_STATUS[error.code]) {
                msg = (React__default.createElement("p", null,
                    error.message,
                    React__default.createElement("br", null),
                    GUACAMOLE_STATUS[error.code].name,
                    React__default.createElement("br", null),
                    GUACAMOLE_STATUS[error.code].text));
            }
            openNotificationWithIcon(notification.error, t('Error'), msg);
        };
        // Setup connection parameters, like resolution and supported audio types
        var connectionParams = {
            audio: [],
        };
        // if current instance is allowed to control remote display size -
        // include window size in connection info
        connectionParams.width = (_a = displayRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        connectionParams.height = (_b = displayRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight;
        // eslint-disable-next-line @typescript-eslint/camelcase
        if (siteId)
            connectionParams.site_id = siteId;
        connectionParams.audio = Guacamole.AudioPlayer.getSupportedTypes() || [];
        // Set connection parameters as we will use them later to reconnect
        connectParamsRef.current = connectionParams;
        // Everything has been setup - we can initiate connection
        var params = getConnectionString().params;
        try {
            (_c = guacRef.current) === null || _c === void 0 ? void 0 : _c.connect(params);
        }
        catch (e) {
            console.error('Error connecting: ', e);
            openNotificationWithIcon(notification.error, t('Error'), React__default.createElement("p", null, String(e)));
        }
        guacRef.current.onfile = function (stream, mimetype, filename) {
            var blobReader = new Guacamole.BlobReader(stream, mimetype);
            blobReader.onend = function () {
                var blobUrl = URL.createObjectURL(blobReader.getBlob());
                if (downloadLink.current) {
                    var link = downloadLink.current;
                    link.href = blobUrl;
                    link.download = filename;
                    link.click();
                }
            };
            stream.sendAck('OK', 0x000);
        };
        // This effect creates Guacamole.Keyboard / Guacamole.Mouse on current display element and binds callbacks
        // to current guacamole client
        if (guacRef.current && guacRef && !readonly) {
            // Keyboard
            var keyboard = new Guacamole.Keyboard(displayRef.current);
            var fixKeys_1 = function (keysym) {
                // 65508 - Right Ctrl
                // 65507 - Left Ctrl
                // somehow Right Ctrl is not sent, so send Left Ctrl instead
                if (keysym === 65508)
                    return 65507;
                return keysym;
            };
            keyboard.onkeydown = function (keysym) {
                var _a;
                // if (state !== GUACAMOLE_CLIENT_STATES.STATE_CONNECTED) return false;
                (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.sendKeyEvent(1, fixKeys_1(keysym));
                return true;
            };
            keyboard.onkeyup = function (keysym) {
                var _a;
                // if (state !== GUACAMOLE_CLIENT_STATES.STATE_CONNECTED) return;
                (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.sendKeyEvent(0, fixKeys_1(keysym));
            };
            // Mouse
            var mouse = new Guacamole.Mouse(displayRef.current);
            mouse.onmousemove = function (mouseState) {
                var _a;
                // if (state !== GUACAMOLE_CLIENT_STATES.STATE_CONNECTED) return;
                mouseState.x = mouseState.x / scale.current;
                mouseState.y = mouseState.y / scale.current;
                (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.sendMouseState(mouseState);
            };
            mouse.onmousedown = mouse.onmouseup = function (mouseState) {
                var _a;
                // if (state !== GUACAMOLE_CLIENT_STATES.STATE_CONNECTED) return;
                (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.sendMouseState(mouseState);
            };
        }
        if (guacRef.current && displayRef.current) {
            displayRef.current.appendChild((_d = guacRef.current) === null || _d === void 0 ? void 0 : _d.getDisplay().getElement());
            displayRef.current.focus();
            // Specify how to clean up after this effect:
            return function cleanup() {
                var _a;
                // Disconnect Guacamole Client, so server know'w we don't need any updates and teminates connection
                // to server
                if (guacRef.current)
                    (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
            };
        }
    }, [authCookieReady, sandboxLoading]);
    var onResize = _.debounce(function (data) {
        setDimensions([(data === null || data === void 0 ? void 0 : data.width) || width, (data === null || data === void 0 ? void 0 : data.height) || height]);
        updateDisplaySize((data === null || data === void 0 ? void 0 : data.width) || width, (data === null || data === void 0 ? void 0 : data.height) || height);
    }, 500);
    var containerRef = useResizeObserver({
        onResize: onResize,
    }).ref;
    var preventDefault = function (e) {
        e.preventDefault();
    };
    return (React__default.createElement("div", { style: readonly
            ? {
                opacity: state === GUACAMOLE_CLIENT_STATES.STATE_DISCONNECTED ? 0.5 : 1,
                transformOrigin: 'top left',
                transform: "scale(".concat(!!((_b = guacRef.current) === null || _b === void 0 ? void 0 : _b.getDisplay().getWidth()) && !!containerWidth
                    ? Math.min(containerWidth / ((_c = guacRef.current) === null || _c === void 0 ? void 0 : _c.getDisplay().getWidth()), 1)
                    : '0.1'),
            }
            : {
                height: '100vh',
                padding: 0,
                margin: 0,
                border: 0,
                overflow: 'hidden',
            } },
        React__default.createElement("style", null, 'body {overflow: auto !important};'),
        !readonly && (React__default.createElement(ActionBar, { component: component },
            React__default.createElement(FlexBar, { h: "between", v: "center" },
                React__default.createElement("div", null, fetchedSession.loading ? (React__default.createElement(Loading, null)) : (React__default.createElement(Brand, { logo: React__default.createElement(React__default.Fragment, null), subtitle: fetchedSession.data.asset_object.name }))),
                React__default.createElement("div", null, (sandboxLoading && null) || stateLabel(state)),
                React__default.createElement(FlexBarRight, { h: "end", v: "center" },
                    fetchedSession.data.is_recorded && (React__default.createElement(StatusIndicator, { variant: state === GUACAMOLE_CLIENT_STATES.STATE_CONNECTED
                            ? 'red'
                            : 'grey', label: t('This session is being recorded'), blink: state === GUACAMOLE_CLIENT_STATES.STATE_CONNECTED })),
                    state >= GUACAMOLE_CLIENT_STATES.STATE_CONNECTED && (React__default.createElement("div", null,
                        (sandboxStatus.ready && sandboxApi && React__default.createElement(FileTransferMenu, { api: sandboxApi })) ||
                            null,
                        ' ',
                        React__default.createElement(ClipboardMenu, { clipboardValue: clipboardValue, onClipboardChanged: function (x) {
                                // setClipboardValue(x);
                                guacRef.current && sendClipboard(guacRef.current, x);
                            } }))),
                    React__default.createElement("div", null,
                        state >= GUACAMOLE_CLIENT_STATES.STATE_CONNECTED && (React__default.createElement(Button, { ghost: false, variant: 'primary', theming: typedComponent, colorOverrides: { border: '#fff' }, onClick: function () { var _a; return (_a = guacRef.current) === null || _a === void 0 ? void 0 : _a.disconnect(); }, disabled: state > GUACAMOLE_CLIENT_STATES.STATE_DISCONNECTED, loading: state === GUACAMOLE_CLIENT_STATES.STATE_DISCONNECTING }, t('Disconnect'))),
                        React__default.createElement("a", { href: "#", download: "", ref: downloadLink })))))),
        React__default.createElement("div", { ref: containerRef, style: { height: 'calc(100vh - 3.5rem)' } },
            (sandboxLoading && (React__default.createElement(SandboxLoader, { sandboxType: sandboxLoading, pod: sandboxStatus }))) ||
                null,
            authCookieReady && !sandboxLoading ? (React__default.createElement("div", { onClick: parentOnClickHandler, onKeyDown: preventDefault, onKeyPress: preventDefault, onKeyUp: preventDefault, ref: displayRef, style: readonly
                    ? undefined
                    : {
                        overflow: 'hidden',
                        cursor: 'none',
                        width: 'calc(100% - 0px)',
                        height: 'calc(100vh - 3.5rem)',
                        outline: 'none',
                        position: 'relative',
                        zIndex: 1,
                        boxSizing: 'content-box',
                    }, tabIndex: 0 })) : (React__default.createElement(React__default.Fragment, null))),
        React__default.createElement(Modal$1, { title: "".concat(t('Disconnected')), cancelText: t('Close'), onCancel: function () { return window.close(); }, 
            // onCancel={closeModal}
            okButtonProps: { style: { display: 'none' } }, visible: state === GUACAMOLE_CLIENT_STATES.STATE_DISCONNECTED || !!terminate },
            React__default.createElement("p", null, terminate || t('Remote session closed.')))));
}
var ActionBar = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  height: 3.5rem;\n  padding: 13px;\n  background: ", ";\n  color: white;\n"], ["\n  height: 3.5rem;\n  padding: 13px;\n  background: ", ";\n  color: white;\n"])), function (p) {
    return p.theme.colors[p.component].primary.main;
});
var FlexBar = styled(Flex)(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
var FlexBarRight = styled(Flex)(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  > div {\n    margin-left: 10px;\n  }\n"], ["\n  > div {\n    margin-left: 10px;\n  }\n"])));
var templateObject_1$c, templateObject_2$3, templateObject_3$3, templateObject_4$2, templateObject_5$2;

var emitTokenRefreshEvent = function (rootId) {
    /**
     * Emit a custom `token-refresh` event on the root element.
     * Triggerred only when token is refreshed.
     */
    var root = document.getElementById(rootId);
    if (!root) {
        console.warn("Root element not found by id ".concat(rootId));
        return;
    }
    root.dispatchEvent(new CustomEvent('token-refresh', {}));
};
function keycloakEntry(url, _a, RootElement, rootId) {
    var access = _a.access, refresh = _a.refresh, oneTimeToken = _a.oneTimeToken;
    if (rootId === void 0) { rootId = 'root'; }
    return __awaiter(this, void 0, void 0, function () {
        var tokens, response, result, e_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    tokens = { access: access, refresh: refresh };
                    if (!(!access && oneTimeToken)) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch('/api/auth/ott/', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ token: oneTimeToken }),
                        })];
                case 2:
                    response = _b.sent();
                    if (response.status > 210) {
                        console.warn('One-time-token authentication failed. Discarding token.');
                        return [2 /*return*/, removeSearchParam('token', true)];
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _b.sent();
                    tokens = __assign({}, result);
                    sessionStorage.setItem('token', tokens.access || '');
                    sessionStorage.setItem('refresh-token', tokens.refresh || '');
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    console.warn('One-time-token auth failed.', e_1);
                    return [2 /*return*/, removeSearchParam('token', true)];
                case 5: return [2 /*return*/, fetch(url).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        var config, keycloak, keycloakRefresh;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, response.json()];
                                case 1:
                                    config = _a.sent();
                                    keycloak = Keycloak(config);
                                    keycloakRefresh = function () {
                                        keycloak
                                            .updateToken(70)
                                            .then(function (refreshed) {
                                            if (refreshed) {
                                                if (keycloak.token) {
                                                    sessionStorage.setItem('token', keycloak.token);
                                                    emitTokenRefreshEvent(rootId);
                                                }
                                                if (keycloak.refreshToken)
                                                    sessionStorage.setItem('refresh-token', keycloak.refreshToken);
                                            }
                                            removeSearchParam('token', false);
                                        })
                                            .catch(function () {
                                            console.error('Failed to refresh token');
                                        });
                                    };
                                    keycloak
                                        .init({
                                        onLoad: 'login-required',
                                        token: tokens.access,
                                        refreshToken: tokens.refresh,
                                        checkLoginIframe: false,
                                        redirectUri: removeSearchParam('token', null),
                                    })
                                        .then(function (auth) {
                                        if (!auth) {
                                            sessionStorage.removeItem('token');
                                            sessionStorage.removeItem('refresh-token');
                                            window.location.reload();
                                            return;
                                        }
                                        if (keycloak.token)
                                            sessionStorage.setItem('token', keycloak.token);
                                        if (keycloak.refreshToken)
                                            sessionStorage.setItem('refresh-token', keycloak.refreshToken);
                                        var rootEl = document.getElementById(rootId);
                                        if (rootEl)
                                            ReactDOM.render(React__default.createElement(RootElement, { keycloak: keycloak }), rootEl);
                                        window.setInterval(keycloakRefresh, 30000);
                                    })
                                        .catch(function () {
                                        console.error('Authenticated Failed');
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            }
        });
    });
}

// import { openNotificationWithIcon } from 'utils';
// import { notification } from 'antd';
// import { GUACAMOLE_STATUS } from '../utils/guacamole/constants';
/* ------------------------------
 * Helper functions
 * ------------------------------*/
var zeroPad = function (num, minLength) {
    if (minLength === void 0) { minLength = 2; }
    /**
     * Add leading zeroes until string is long enough
     */
    var str = num.toString();
    while (str.length < minLength)
        str = '0' + str;
    return str;
};
var formatTime = function (value) {
    /**
     * Format seconds and minutes as MM:SS
     */
    var totalSeconds = Math.floor(value / 1000);
    var seconds = totalSeconds % 60;
    var minutes = Math.floor(totalSeconds / 60);
    return "".concat(zeroPad(minutes), ":").concat(zeroPad(seconds));
};
var PlayButton = function (_a) {
    var state = _a.state, onClick = _a.onClick;
    var icon = state === 'pause' ? faPlay : faPause;
    return (React__default.createElement(Button, { theming: "site", ghost: false, onClick: onClick },
        React__default.createElement(FontAwesomeIcon, { icon: icon })));
};
var PositionDuration = function (_a) {
    var position = _a.position, duration = _a.duration;
    return (React__default.createElement("div", null,
        React__default.createElement("span", null, formatTime(position)),
        React__default.createElement("span", null, "/"),
        React__default.createElement("span", null, formatTime(duration))));
};
function RemoteRecordingPlayer(_a) {
    // const [t] = useTranslation(['remoteAccess', 'common']);
    var session = _a.session, onDuration = _a.onDuration, onResize = _a.onResize, _b = _a.bearer, bearer = _b === void 0 ? sessionStorage.getItem('token') || undefined : _b;
    var url = "/api/remote-session/".concat(session.id, "/recording/");
    var _c = __read(useState('pause'), 2), state = _c[0], setState = _c[1];
    var _d = __read(useState(false), 2), loading = _d[0], setLoading = _d[1];
    // const [error, setError] = useState<string | null>(null);
    var _e = __read(useState(), 2), recording = _e[0], setRecording = _e[1];
    var _f = __read(useState(0), 2), duration = _f[0], setDuration = _f[1];
    var _g = __read(useState(0), 2), position = _g[0], setPosition = _g[1];
    // const player = useRef<HTMLDivElement | null>(null);
    var display = useRef$1(null);
    var onDurationDebounced = onDuration
        ? debounce(onDuration, 300)
        : undefined;
    useEffect$1(function () {
        var tunnel = new Guacamole.StaticHTTPTunnel(url, false, {
            Authorization: "Bearer ".concat(bearer),
        });
        var recording = new Guacamole.SessionRecording(tunnel);
        var recordingDisplay = recording.getDisplay();
        if (display.current === null)
            return;
        display.current.appendChild(recordingDisplay.getElement());
        recording.connect();
        setRecording(recording);
        recording.onplay = function () {
            setState('play');
        };
        recording.onpause = function () {
            setState('pause');
        };
        recording.onseek = function (millis) {
            setPosition(millis);
        };
        // Update slider and status when duration changes
        recording.onprogress = function (millis) {
            if (millis === 0)
                return;
            var first = millis < 2000;
            setDuration(millis);
            if (first)
                recording.seek(0);
            if (onDurationDebounced)
                setTimeout(function () { return onDurationDebounced(millis); }, 0);
        };
        recordingDisplay.onresize = function (width, height) {
            // Do not scale if display has no width
            if (!width)
                return;
            // Scale display to fit width of container
            if (display.current)
                recordingDisplay.scale(display.current.offsetWidth / width);
            // call optional eventhandler
            if (onResize)
                onResize(width, height);
        };
    }, [url]);
    var playButtonClick = function () {
        if (!recording) {
            return;
        }
        if (!recording.isPlaying())
            recording.play();
        else
            recording.pause();
    };
    var sliderPositionChanged = function (value) {
        if (!recording) {
            console.warn('Recording not ready');
            return;
        }
        if (Array.isArray(value))
            value = value[0];
        recording.seek(value, function () { return setLoading(false); });
        setLoading(true);
    };
    return (React__default.createElement(Player, null,
        React__default.createElement(Spin, { spinning: loading || duration === 0 },
            React__default.createElement(Display, { ref: display })),
        React__default.createElement(Flex, { h: "between" },
            React__default.createElement(PlayButton, { state: state, onClick: playButtonClick }),
            React__default.createElement(Slider, { onChange: sliderPositionChanged, min: 0, value: position, max: duration, tipFormatter: function (millies) { return React__default.createElement("span", null, formatTime(millies || 0)); }, disabled: duration === 0 }),
            React__default.createElement(PositionDuration, { position: position, duration: duration }))));
}
var Player = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Display = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  position: relative;\n  min-height: 480px;\n  overflow-y: hidden;\n"], ["\n  position: relative;\n  min-height: 480px;\n  overflow-y: hidden;\n"])));
var Slider = styled(Slider$1)(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  width: 100%;\n  margin: 10px 20px;\n"], ["\n  width: 100%;\n  margin: 10px 20px;\n"])));
var templateObject_1$d, templateObject_2$4, templateObject_3$4;

var colorVariants = {
    site: '#417e80',
    center: '#004f9b',
};
var Wrapper = styled.div(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.375;\n  color: #1c2c41;\n  text-align: left;\n  font-family: sans-serif;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n\n  .error-code {\n    color: #888e9a;\n    margin-bottom: 1rem;\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n  }\n  .error-text {\n    margin-bottom: 1rem;\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 1.2;\n    color: rgba(0, 0, 0, 0.85);\n    margin-top: 0;\n  }\n  .error-solution {\n    color: #888e9a;\n    font-weight: 400;\n    margin-bottom: 1.5rem;\n    line-height: 1.2;\n    margin-top: 0;\n  }\n  .go-back-button {\n    display: inline-block;\n    font-weight: 600;\n    color: #fff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    line-height: 1.375;\n    border-radius: 3px;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.03);\n  }\n  .go-back-button--back {\n    align-items: center;\n    display: flex;\n  }\n  .go-back-button--back > span {\n    margin-left: 4px;\n  }\n  ", "\n"], ["\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.375;\n  color: #1c2c41;\n  text-align: left;\n  font-family: sans-serif;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n\n  .error-code {\n    color: #888e9a;\n    margin-bottom: 1rem;\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n  }\n  .error-text {\n    margin-bottom: 1rem;\n    font-size: 1.75rem;\n    font-weight: 600;\n    line-height: 1.2;\n    color: rgba(0, 0, 0, 0.85);\n    margin-top: 0;\n  }\n  .error-solution {\n    color: #888e9a;\n    font-weight: 400;\n    margin-bottom: 1.5rem;\n    line-height: 1.2;\n    margin-top: 0;\n  }\n  .go-back-button {\n    display: inline-block;\n    font-weight: 600;\n    color: #fff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    line-height: 1.375;\n    border-radius: 3px;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.03);\n  }\n  .go-back-button--back {\n    align-items: center;\n    display: flex;\n  }\n  .go-back-button--back > span {\n    margin-left: 4px;\n  }\n  ", "\n"])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n      .go-back-button {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "], ["\n      .go-back-button {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "])), colorVariants[variant], colorVariants[variant]);
});
var AccessDenied = function (props) {
    return (React__default.createElement(Wrapper, __assign({}, props),
        React__default.createElement("div", { className: "error-code" }, "Access denied"),
        React__default.createElement("h1", { className: "error-text" }, "You are not allowed to login here."),
        React__default.createElement("p", { className: "" }, "Please contact your site focal point."),
        React__default.createElement("button", { className: "go-back-button", onClick: function () { return (window.location.href = '/api/auth/logout/'); } },
            React__default.createElement("div", { className: "go-back-button--back" },
                React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "mr-1" },
                    React__default.createElement("line", { x1: "19", y1: "12", x2: "5", y2: "12" }),
                    React__default.createElement("polyline", { points: "12 19 5 12 12 5" })),
                React__default.createElement("span", null, "Logout")))));
};
var templateObject_1$e, templateObject_2$5;

var UserContext = React__default.createContext({
    user: null,
    accessDenied: false,
    fetchMe: function () {
        return;
    },
    path: '',
});
function UserProvider(_a) {
    var _this = this;
    var children = _a.children, _b = _a.url, url = _b === void 0 ? '/api/me/' : _b, 
    // opUrl = '/api/user/:userId/object-permissions/',
    onFail = _a.onFail, _c = _a.path, path = _c === void 0 ? 'permissions' : _c, variant = _a.variant;
    var _d = __read(useState(), 2), meWithObjPerms = _d[0], setMeWithObjPerms = _d[1];
    var _e = __read(useState(false), 2), accessDenied = _e[0], setAccessDenied = _e[1];
    var _f = __read(useFetch({
        url: url,
        defaultValue: null,
        initialFetch: false,
        onFail: function (x) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (x.error === 403) {
                    setAccessDenied(true);
                }
                else {
                    onFail && onFail(x);
                }
                return [2 /*return*/];
            });
        }); },
        onSucces: function (_a) {
            var data = _a.data;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    setMeWithObjPerms(data);
                    return [2 /*return*/];
                });
            });
        },
    }), 2), me = _f[0], fetchMe = _f[1];
    useEffect$1(function () {
        url && fetchMe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);
    if (accessDenied)
        return React__default.createElement(AccessDenied, { variant: variant });
    return meWithObjPerms ? (React__default.createElement(UserContext.Provider, { value: { user: meWithObjPerms, fetchMe: fetchMe, path: path, accessDenied: accessDenied } }, me.data ? children : null)) : null;
}
function checkAnyPermission(codename, permissions) {
    if (Array.isArray(codename)) {
        return codename.some(function (cn) { return permissions.includes(cn); });
    }
    return permissions.includes(codename);
}
function checkGlobalPermission(codename, permissions) {
    if (Array.isArray(codename)) {
        return codename.some(function (cn) { return !!permissions.find(function (p) { return p.codename === cn; }); });
    }
    return !!permissions.find(function (p) { return p.codename === codename; });
}
var checkObjectPermission = function (codename, objectId, permissions) {
    if (Object.keys(permissions).length === 0 || !permissions[objectId])
        return false;
    var permissionsForObject = Object.entries(permissions[objectId]).map(function (x) { return x[1]; });
    var hasPermission = function (cn) {
        return permissionsForObject.findIndex(function (pfo) { return pfo.codename === cn; }) > -1;
    };
    if (Array.isArray(codename)) {
        return codename.some(function (c) {
            return hasPermission(c);
        });
    }
    else {
        return hasPermission(codename);
    }
};
function PermissionGuard(_a) {
    var codename = _a.codename, children = _a.children, redirect = _a.redirect, objectId = _a.objectId, _b = _a.any, any = _b === void 0 ? false : _b;
    var _c = useContext(UserContext), user = _c.user, path = _c.path;
    var redirection = React__default.createElement(Redirect, { to: "/" });
    var success = React__default.createElement(React__default.Fragment, null, children);
    var fail = null;
    if (user === null || user === void 0 ? void 0 : user.is_superuser)
        return success;
    if (!user && redirect)
        return redirection;
    if (!user)
        return fail;
    var hasGlobalPermission = any
        ? checkAnyPermission(codename, get$1(user, 'permissions.all_codenames', []))
        : checkGlobalPermission(codename, get$1(user, 'permissions.global', []));
    if (hasGlobalPermission)
        return success;
    if (!hasGlobalPermission && !objectId && redirect)
        return redirection;
    if (!hasGlobalPermission && !objectId)
        return fail;
    if (!objectId)
        return fail;
    var hasObjectPermission = checkObjectPermission(codename, objectId, get$1(user, 'permissions.object', null));
    if (redirect && !hasObjectPermission)
        return redirection;
    if (!hasObjectPermission)
        return fail;
    return success;
}
function useUserinfo(objectId) {
    var _a = useContext(UserContext), user = _a.user, fetchMe = _a.fetchMe, path = _a.path;
    var check = function (codename) {
        if (user === null || user === void 0 ? void 0 : user.is_superuser)
            return true;
        if (!user)
            return false;
        var hasGlobalPermission = checkGlobalPermission(codename, get$1(user, 'permissions.global', null));
        if (hasGlobalPermission)
            return true;
        if (!objectId)
            return false;
        return checkObjectPermission(codename, objectId, get$1(user, 'permissions.object', null));
    };
    var checkAny = function (codename) {
        if (user === null || user === void 0 ? void 0 : user.is_superuser)
            return true;
        if (!user)
            return false;
        return checkAnyPermission(codename, (user === null || user === void 0 ? void 0 : user.permissions.all_codenames) || []);
    };
    return [check, fetchMe, user, checkAny];
}

var Vertical = styled.div(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  width: 1px;\n  height: 38px;\n  background: #d8d8d8;\n  margin-right: 1.4rem;\n  margin-left: 0rem;\n"], ["\n  width: 1px;\n  height: 38px;\n  background: #d8d8d8;\n  margin-right: 1.4rem;\n  margin-left: 0rem;\n"])));
var Horizontal = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  margin: 1rem 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.09);\n"], ["\n  margin: 1rem 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.09);\n"])));
var Divider = function (_a) {
    var vertical = _a.vertical;
    return vertical ? React__default.createElement(Vertical, null) : React__default.createElement(Horizontal, null);
};
var templateObject_1$f, templateObject_2$6;

var Chevron = styled(FontAwesomeIcon)(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  transition: transform 0.2s ease-out;\n"], ["\n  transition: transform 0.2s ease-out;\n"])));
var FilterContainer = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n"])));
var FilterSidebar = function (_a) {
    var children = _a.children;
    return React__default.createElement(FilterContainer, null, children);
};
var FilterHeader = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  cursor: pointer;\n  margin-top: 1rem;\n  font-style: italic;\n  font-weight: 200;\n  text-transform: uppercase;\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  cursor: pointer;\n  margin-top: 1rem;\n  font-style: italic;\n  font-weight: 200;\n  text-transform: uppercase;\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n"])));
function Header(_a) {
    var title = _a.title, isOpen = _a.isOpen, props = __rest(_a, ["title", "isOpen"]);
    return (React__default.createElement(FilterHeader, __assign({}, props),
        title,
        React__default.createElement(Chevron, { icon: faChevronDown, rotation: isOpen ? undefined : 90 })));
}
var FilterItem = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  word-break: break-all;\n  white-space: normal;\n  padding: 0.5rem 1rem;\n  background: none;\n  border: 0;\n  border-radius: 3px;\n  cursor: pointer;\n  overflow: hidden;\n\n  ", "\n"], ["\n  word-break: break-all;\n  white-space: normal;\n  padding: 0.5rem 1rem;\n  background: none;\n  border: 0;\n  border-radius: 3px;\n  cursor: pointer;\n  overflow: hidden;\n\n  ", "\n"])), function (p) {
    return p.isActive
        ? css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n          color: ", ";\n          background: ", "0f;\n        "], ["\n          color: ", ";\n          background: ", "0f;\n        "])), function (p) { return p.theme.colors[p.theming].primary.main; }, function (p) { return p.theme.colors[p.theming].primary.main; }) : css(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n          &:hover,\n          &:focus {\n            color: ", ";\n            background: ", "29;\n          }\n        "], ["\n          &:hover,\n          &:focus {\n            color: ", ";\n            background: ", "29;\n          }\n        "])), function (p) { return p.theme.colors[p.theming].primary.main; }, function (p) { return p.theme.colors[p.theming].primary.main; });
});
function Item(_a) {
    var title = _a.title, onClick = _a.onClick, _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.theming, theming = _c === void 0 ? 'center' : _c, props = __rest(_a, ["title", "onClick", "active", "theming"]);
    var _d = __read(useState(active), 2), isActive = _d[0], setIsActive = _d[1];
    var handleOnClick = useCallback(function () {
        if (onClick) {
            onClick();
        }
        setIsActive(!isActive);
    }, [isActive, onClick]);
    return (React__default.createElement(FilterItem, __assign({}, props, { onClick: handleOnClick, "data-ta": "filterItem-".concat(title), theming: theming, isActive: isActive }), title));
}
var FilterGroup = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n"])));
function Group(_a) {
    var children = _a.children, title = _a.title, _b = _a.isOpen, IsOpenProp = _b === void 0 ? false : _b;
    var _c = __read(useState(IsOpenProp), 2), isOpen = _c[0], setIsOpen = _c[1];
    var toggle = function () { return setIsOpen(!isOpen); };
    return (React__default.createElement(React__default.Fragment, null,
        title && (React__default.createElement(Header, { title: title, onClick: toggle, isOpen: isOpen, "data-ta": "filterHeader-".concat(title) })),
        React__default.createElement(FilterGroup, { "data-ta": "filter-".concat(title) },
            React__default.createElement("div", null, children))));
}
FilterSidebar.Header = Header;
FilterSidebar.Item = Item;
FilterSidebar.Group = Group;
var templateObject_1$g, templateObject_2$7, templateObject_3$5, templateObject_4$3, templateObject_5$3, templateObject_6$1, templateObject_7$1;

var StyledCollapse = styled(Collapse)(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  border: none;\n  background: none;\n\n  .ant-collapse-content {\n    border: none !important;\n  }\n\n  .ant-collapse-content-box {\n    padding: 0;\n  }\n\n  .ant-collapse {\n    &-item {\n      border: none;\n      padding: 0;\n    }\n\n    &-arrow {\n      right: 0px !important;\n    }\n\n    &-header {\n      cursor: pointer;\n      border: none !important;\n      margin-top: 1rem;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      padding: 0 !important;\n      font-weight: 200;\n      text-transform: uppercase;\n      font-style: italic;\n    }\n  }\n"], ["\n  border: none;\n  background: none;\n\n  .ant-collapse-content {\n    border: none !important;\n  }\n\n  .ant-collapse-content-box {\n    padding: 0;\n  }\n\n  .ant-collapse {\n    &-item {\n      border: none;\n      padding: 0;\n    }\n\n    &-arrow {\n      right: 0px !important;\n    }\n\n    &-header {\n      cursor: pointer;\n      border: none !important;\n      margin-top: 1rem;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      padding: 0 !important;\n      font-weight: 200;\n      text-transform: uppercase;\n      font-style: italic;\n    }\n  }\n"])));
function PageSidebar(_a) {
    var _b;
    var search = _a.search, availableFilters = _a.availableFilters, toggleFilter = _a.toggleFilter, _c = _a.theming, theming = _c === void 0 ? 'center' : _c, _d = _a.selectedFilters, selectedFilters = _d === void 0 ? {} : _d;
    var filterKeys = Object.keys(availableFilters);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Input, { onChange: function (_a) {
                var value = _a.currentTarget.value;
                search.set(value);
            }, value: search.value, style: { width: '100%' }, placeholder: "Search" }),
        filterKeys.length > 0 && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Divider, null),
            React__default.createElement(StyledCollapse, { expandIconPosition: "right", defaultActiveKey: (_b = Object === null || Object === void 0 ? void 0 : Object.keys(selectedFilters)) === null || _b === void 0 ? void 0 : _b.filter(function (key) { var _a; return ((_a = selectedFilters[key]) === null || _a === void 0 ? void 0 : _a.length) !== 0; }) }, filterKeys.map(function (key) { return (React__default.createElement(StyledCollapse.Panel, { key: key, header: React__default.createElement("span", { "data-ta": "filterPanel-".concat(key) }, availableFilters[key].label) }, availableFilters[key].options.map(function (x) {
                var _a, _b;
                return (React__default.createElement(FilterSidebar.Item, { theming: theming, key: x.value, title: x.label, onClick: function () {
                        toggleFilter(key, x.value);
                    }, active: ((_a = selectedFilters[key]) === null || _a === void 0 ? void 0 : _a.includes(x.label)) ||
                        ((_b = selectedFilters[key]) === null || _b === void 0 ? void 0 : _b.includes(x.value)) }));
            }))); }))))));
}
var templateObject_1$h;

function SearchFilterDropdown(_a) {
    var confirm = _a.confirm, clearFilters = _a.clearFilters, setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, dataKey = _a.dataKey, handleSearch = _a.handleSearch, handleReset = _a.handleReset, visible = _a.visible;
    var inputRef = useRef$1(null);
    useEffect$1(function () {
        var _a;
        if (visible) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        }
    }, [visible]);
    return (React__default.createElement("div", { style: { padding: 8 } },
        React__default.createElement(Input, { ref: inputRef, placeholder: "Search...", value: selectedKeys[0], onChange: function (e) { return setSelectedKeys(e.target.value ? [e.target.value] : []); }, onPressEnter: function () { return handleSearch(selectedKeys, confirm, dataKey); }, style: { width: 188, marginBottom: 8, display: 'block' } }),
        React__default.createElement(Flex, { h: "start", v: "center" },
            React__default.createElement("button", { className: "btn btn-sm btn-outline-primary d-flex align-items-center", onClick: function () { return handleReset(clearFilters); }, style: { width: 90 } }, "Reset"),
            React__default.createElement("button", { className: "btn btn-sm btn-primary ml-2 d-flex align-items-center", onClick: function () { return handleSearch(selectedKeys, confirm, dataKey); }, style: { width: 90 } }, "Search"))));
}

var Container$4 = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["display: flex;\nflex-direction: column;\npadding-left: 0;\nmargin-bottom: 0;\n}"], ["display: flex;\nflex-direction: column;\npadding-left: 0;\nmargin-bottom: 0;\n}"])));
function Sidebar(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(Container$4, __assign({}, props), children);
}
var StyledNavLink = styled(NavLink)(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  padding: 0.5rem 1rem;\n  background: none;\n  border: 0;\n  border-radius: 3px;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n\n  .sidebar-icon {\n    color: ", ";\n    width: 1rem;\n    margin-right: 1rem;\n  }\n\n  &:hover:not(.sidebar-active) {\n    color: ", ";\n    background: ", "29;\n  }\n\n  &.sidebar-active {\n    color: ", ";\n    background: ", "0f;\n\n    .sidebar-icon {\n      color: inherit;\n    }\n  }\n"], ["\n  padding: 0.5rem 1rem;\n  background: none;\n  border: 0;\n  border-radius: 3px;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n\n  .sidebar-icon {\n    color: ", ";\n    width: 1rem;\n    margin-right: 1rem;\n  }\n\n  &:hover:not(.sidebar-active) {\n    color: ", ";\n    background: ", "29;\n  }\n\n  &.sidebar-active {\n    color: ", ";\n    background: ", "0f;\n\n    .sidebar-icon {\n      color: inherit;\n    }\n  }\n"])), function (p) { return p.theme.colors.common.grey500; }, function (p) { return p.theme.colors[p.theming].primary.main; }, function (p) { return p.theme.colors[p.theming].primary.main; }, function (p) { return p.theme.colors[p.theming].primary.main; }, function (p) { return p.theme.colors[p.theming].primary.main; });
var SidebarItem = function (_a) {
    var title = _a.title, icon = _a.icon, url = _a.url, _b = _a.theming, theming = _b === void 0 ? 'center' : _b, props = __rest(_a, ["title", "icon", "url", "theming"]);
    var match = useRouteMatch();
    var toUrl = match.url === '/' ? "".concat(match.url).concat(url) : "".concat(match.url, "/").concat(url);
    return (React__default.createElement(StyledNavLink, __assign({ to: toUrl, activeClassName: 'sidebar-active', theming: theming }, props),
        React__default.createElement("span", { className: "sidebar-icon" }, icon),
        title));
};
Sidebar.Item = SidebarItem;
var templateObject_1$i, templateObject_2$8;

var Label$1 = styled.label(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  padding-left: 8px;\n  cursor: pointer;\n  margin-bottom: 1rem;\n"], ["\n  padding-left: 8px;\n  cursor: pointer;\n  margin-bottom: 1rem;\n"])));
function Switch(_a) {
    var _b = _a.isChecked, isChecked = _b === void 0 ? false : _b, onChange = _a.onChange, label = _a.label, props = __rest(_a, ["isChecked", "onChange", "label"]);
    var _c = __read(useState(isChecked), 2), checked = _c[0], setChecked = _c[1];
    var onChangeHandler = function (val, e) {
        if (onChange) {
            onChange(val, e);
        }
        setChecked(!checked);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Switch$1, __assign({ checked: checked, onChange: onChangeHandler }, props)),
        label && props.id && React__default.createElement(Label$1, { htmlFor: props.id }, label)));
}
var templateObject_1$j;

function IconWrapper(_a) {
    var size = _a.size, Icon = _a.icon, rest = __rest(_a, ["size", "icon"]);
    return React__default.createElement(Icon, __assign({ size: size }, rest));
}
var MssIcon = styled(IconWrapper)(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n"], ["\n  height: ", ";\n  width: ", ";\n"])), function (p) { return (p.size ? "".concat(p.size, "px") : '18px'); }, function (p) { return (p.size ? "".concat(p.size, "px") : '18px'); });
var templateObject_1$k;

var RequestStatus = function (_a) {
    var status = _a.status;
    var _b = __read(useTranslation(['common']), 1), t = _b[0];
    if (typeof status !== 'string')
        return null;
    switch (status.toLowerCase()) {
        case 'awaiting_approval':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "yellow" }),
                " ",
                t('Awaiting approval')));
        case 'allow':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "green" }),
                " ",
                t('Approved')));
        case 'denied':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "red" }),
                " ",
                t('Denied')));
        case 'revoked':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "red" }),
                " ",
                t('Revoked')));
        case 'wait_for_start_date':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "green" }),
                " ",
                t('Future approved')));
        case 'expired':
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(StatusIndicator, { variant: "red" }),
                " ",
                t('Expired')));
        default:
            return null;
    }
};

var SubmitButton = function (_a) {
    var children = _a.children, theming = _a.theming, restProps = __rest(_a, ["children", "theming"]);
    return (React__default.createElement(Field, null, function (_a) {
        var _b = _a.form, isSubmitting = _b.isSubmitting, isValid = _b.isValid, dirty = _b.dirty, submitCount = _b.submitCount;
        return (React__default.createElement(Button, __assign({ theming: theming, loading: isSubmitting, variant: "primary", htmlType: "submit", disabled: !isValid && (dirty || submitCount > 0), "data-ta": "submitButton" }, restProps), children));
    }));
};

var VerticalRadio = styled(Radio)(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  display: block;\n  line-height: 30px;\n"], ["\n  display: block;\n  line-height: 30px;\n"])));
var templateObject_1$l;

var RowAction = styled(Button$1)(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  border: none;\n  &:hover,\n  &:active {\n    background: ", ";\n  }\n"], ["\n  border: none;\n  &:hover,\n  &:active {\n    background: ", ";\n  }\n"])), function (p) { return p.theme.colors.common.grey400; });
var RowActionButton = function (_a) {
    var props = __rest(_a, []);
    return (React__default.createElement(RowAction, __assign({ style: { height: 24, width: 24 } }, props)));
};
var templateObject_1$m;

var StepperContainer = styled.ul(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  background: #fff;\n  color: '#ffffff';\n  padding: 0;\n  justify-content: start;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid ", ";\n"], ["\n  background: #fff;\n  color: '#ffffff';\n  padding: 0;\n  justify-content: start;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid ", ";\n"])), function (p) { return p.theme.colors.common.grey200; });
var Stepper = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep, disabled = _a.disabled;
    return (React__default.createElement(StepperContainer, null, steps.map(function (step, index) { return (React__default.createElement(Step, { key: step.value, label: step.label, index: index, currentStep: currentStep, disabled: disabled })); })));
};
var StepContainer = styled.li(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  min-width: 196px;\n  display: flex;\n  align-items: center;\n  color: inherit;\n  padding: 0.5rem 0rem !important;\n  border-bottom: 3px solid transparent;\n  color: ", ";\n  height: 100%;\n\n  &:not(:last-child) {\n    margin-right: 1.4rem;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  min-width: 196px;\n  display: flex;\n  align-items: center;\n  color: inherit;\n  padding: 0.5rem 0rem !important;\n  border-bottom: 3px solid transparent;\n  color: ", ";\n  height: 100%;\n\n  &:not(:last-child) {\n    margin-right: 1.4rem;\n  }\n\n  ", "\n\n  ", "\n"])), function (p) { return p.theme.colors.common.grey300; }, function (p) {
    return p.isActive && css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n      border-bottom-color: ", ";\n      color: inherit;\n      font-weight: 600;\n    "], ["\n      border-bottom-color: ", ";\n      color: inherit;\n      font-weight: 600;\n    "])), function (p) { return p.theme.colors.site.primary.main; });
}, function (p) {
    return p.isDone && css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n      font-weight: 600;\n      cursor: pointer;\n\n      &:hover {\n        border-bottom-color: ", ";\n        color: ", ";\n      }\n    "], ["\n      font-weight: 600;\n      cursor: pointer;\n\n      &:hover {\n        border-bottom-color: ", ";\n        color: ", ";\n      }\n    "])), function (p) {
        return !p.disabled ? p.theme.colors.site.primary.main : 'transparent';
    }, function (p) {
        return !p.disabled
            ? p.theme.colors.site.primary.main
            : p.theme.colors.common.grey300;
    });
});
var Step = function (_a) {
    var label = _a.label, index = _a.index, currentStep = _a.currentStep, disabled = _a.disabled;
    var isActive = index === currentStep.index;
    var isDone = index < currentStep.index;
    var handleClick = function () {
        if (isDone) {
            currentStep.set(index);
        }
    };
    return (React__default.createElement(StepContainer, { disabled: disabled, isActive: isActive, isDone: isDone, onClick: !disabled ? handleClick : undefined }, label));
};
var templateObject_1$n, templateObject_2$9, templateObject_3$6, templateObject_4$4;

var Container$5 = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  margin-bottom: 1rem;\n  display: block;\n"], ["\n  margin-bottom: 1rem;\n  display: block;\n"])));
var FormLabel = styled.label(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  display: block;\n  margin-bottom: 0.375rem;\n  font-size: 14px;\n  font-weight: 600;\n\n  ", "\n"], ["\n  display: block;\n  margin-bottom: 0.375rem;\n  font-size: 14px;\n  font-weight: 600;\n\n  ", "\n"])), function (p) {
    return p.actions && css(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    "], ["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    "])));
});
var FieldError = styled.div(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  color: #fa4654 !important;\n  font-size: 12px;\n  margin: 4px 12px 0 12px;\n"], ["\n  color: #fa4654 !important;\n  font-size: 12px;\n  margin: 4px 12px 0 12px;\n"])));
var RequiredMark = styled.span(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  color: #fa4654 !important;\n  margin-left: 4px;\n"], ["\n  color: #fa4654 !important;\n  margin-left: 4px;\n"])));
var FormGroup = function (_a) {
    var label = _a.label, input = _a.input, error = _a.error, actions = _a.actions, required = _a.required;
    return (React__default.createElement(Container$5, null,
        React__default.createElement(FormLabel, { actions: !!actions },
            React__default.createElement("span", null,
                label,
                required && React__default.createElement(RequiredMark, null, "*")),
            !!actions && actions),
        input,
        error ? React__default.createElement(FieldError, null, error) : null));
};
var templateObject_1$o, templateObject_2$a, templateObject_3$7, templateObject_4$5, templateObject_5$4;

var Content = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject([""], [""])));
var Footer$1 = styled.div(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var Container$6 = styled.div(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"])), function (p) {
    return p.border && css(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), function (p) { return p.theme.colors.common.grey200; });
}, function (p) {
    return p.padding && css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n      > ", ", > ", " {\n        padding: 8px 16px 16px;\n      }\n    "], ["\n      > ", ", > ", " {\n        padding: 8px 16px 16px;\n      }\n    "])), Content, Footer$1);
});
var Header$1 = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: 16px;\n  margin: 8px;\n  padding: 0;\n"], ["\n  font-weight: 600;\n  font-size: 16px;\n  margin: 8px;\n  padding: 0;\n"])));
var RequiredMark$1 = styled.span(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
var Divider$1 = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  display: flex;\n  flex: 0;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto 1rem auto;\n  font-size: 0.875rem;\n  color: #888e9a;\n  letter-spacing: 0.5px;\n  font-weight: 400;\n\n  &:before,\n  &:after {\n    margin: 0;\n    content: '';\n  }\n\n  &:before {\n    flex-grow: 1;\n    border-top: 1px solid rgba(0, 0, 0, 0.09);\n    margin-left: 0.5rem;\n  }\n  &:after {\n    margin-right: 0.5rem;\n  }\n"], ["\n  display: flex;\n  flex: 0;\n  align-items: center;\n  width: 100%;\n  margin: 0 auto 1rem auto;\n  font-size: 0.875rem;\n  color: #888e9a;\n  letter-spacing: 0.5px;\n  font-weight: 400;\n\n  &:before,\n  &:after {\n    margin: 0;\n    content: '';\n  }\n\n  &:before {\n    flex-grow: 1;\n    border-top: 1px solid rgba(0, 0, 0, 0.09);\n    margin-left: 0.5rem;\n  }\n  &:after {\n    margin-right: 0.5rem;\n  }\n"])));
var Segment = function (_a) {
    var heading = _a.heading, children = _a.children, required = _a.required, footer = _a.footer, border = _a.border, padding = _a.padding, style = _a.style, rest = __rest(_a, ["heading", "children", "required", "footer", "border", "padding", "style"]);
    return (React__default.createElement(Container$6, __assign({ border: border, padding: padding, style: style }, rest),
        heading && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Header$1, null,
                heading,
                required && React__default.createElement(RequiredMark$1, null, '*')),
            React__default.createElement(Divider$1, null))),
        React__default.createElement(Content, null, children),
        footer && React__default.createElement(Footer$1, null, footer)));
};
var templateObject_1$p, templateObject_2$b, templateObject_3$8, templateObject_4$6, templateObject_5$5, templateObject_6$2, templateObject_7$2, templateObject_8$1;

var Icon = styled.span(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  font-size: 18px;\n"], ["\n  font-size: 18px;\n"])));
var iconSize = 14;
function StatusTag(_a) {
    var status = _a.status, label = _a.label;
    label = label || status;
    var colorType = {
        new: 'default',
        uploading: 'processing',
        syncing: 'processing',
        ready: 'success',
        expired: 'warning',
        error: 'error',
        locked: 'error',
    };
    var icons = {
        new: React__default.createElement(Clock, { size: iconSize }),
        uploading: React__default.createElement(RefreshCw, { size: iconSize }),
        syncing: React__default.createElement(RefreshCw, { size: iconSize }),
        ready: React__default.createElement(Check, { size: iconSize }),
        expired: React__default.createElement(Slash, { size: iconSize }),
        error: React__default.createElement(AlertTriangle, { size: iconSize }),
        locked: React__default.createElement(Shield, { size: iconSize }),
    };
    return (React__default.createElement(Tag, { color: colorType[status] },
        React__default.createElement(Icon, null, icons[status]),
        " ",
        label));
}
var templateObject_1$q;

/**
 * TODO currently showing log for filetransfer not implemented, yet
 */
var TimelineHeader = styled(Row)(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  h4 {\n    color: rgba(0, 0, 0, 0.65);\n    margin-bottom: 0;\n  }\n  h4.right {\n    text-align: right;\n  }\n"], ["\n  h4 {\n    color: rgba(0, 0, 0, 0.65);\n    margin-bottom: 0;\n  }\n  h4.right {\n    text-align: right;\n  }\n"])));
var LogTable = styled(Table$1)(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  &.ant-table,\n  * .ant-table {\n    input:focus,\n    select:focus,\n    textarea:focus,\n    button:focus {\n      outline: none;\n    }\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"], ["\n  &.ant-table,\n  * .ant-table {\n    input:focus,\n    select:focus,\n    textarea:focus,\n    button:focus {\n      outline: none;\n    }\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"])));
var columns = function (t) { return [
    {
        title: t('id'),
        dataIndex: 'id',
        key: 'id',
    },
    {
        title: t('User'),
        dataIndex: 'user_name',
        key: 'user_name',
    },
    {
        title: t('Size'),
        dataIndex: 'file_size_str',
        key: 'file_size_str',
    },
]; };
function Status(_a) {
    var log = _a.log;
    if (log.oldstatus === log.status)
        return React__default.createElement(React__default.Fragment, null);
    if (log.oldstatus) {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(StatusTag, { status: log.oldstatus }),
            ' ',
            React__default.createElement(ArrowRightOutlined, { className: "mr-2" }),
            React__default.createElement(StatusTag, { status: log.status })));
    }
    return React__default.createElement(StatusTag, { status: log.status });
}
function DetailModal(_a) {
    var t = _a.t, api = _a.api, fileTransfer = _a.fileTransfer, closeModal = _a.closeModal;
    var _b = __read(useState(fileTransfer), 2), details = _b[0], setDetails = _b[1];
    useEffect$1(function () {
        if (!fileTransfer || !fileTransfer.id)
            return;
        api.get(fileTransfer.id).then(function (x) { return setDetails(x); });
    }, [fileTransfer, fileTransfer === null || fileTransfer === void 0 ? void 0 : fileTransfer.updated_at]);
    var close = function () {
        setDetails(null);
        closeModal();
    };
    return (React__default.createElement(Modal$1, { title: "".concat(t('File transfer'), " ").concat(fileTransfer ? ' > ' + (fileTransfer === null || fileTransfer === void 0 ? void 0 : fileTransfer.file_name) : ''), cancelText: t('common:Close'), onCancel: close, okButtonProps: { style: { display: 'none' } }, visible: !!fileTransfer, width: '66%' },
        (fileTransfer && fileTransfer.id && (React__default.createElement(LogTable, { bordered: true, columns: columns(t), dataSource: [fileTransfer], showHeader: true, pagination: false, size: "small" }))) || React__default.createElement(Loading, null),
        React__default.createElement(Card, { className: "mt-2", title: React__default.createElement(TimelineHeader, null,
                React__default.createElement(Col, null,
                    React__default.createElement("h4", { className: 'right mr-8' }, t('Site'))),
                React__default.createElement(Col, null,
                    React__default.createElement("h4", { className: 'ml-8' }, t('Center')))) },
            React__default.createElement(Timeline, { mode: "alternate" }, !details ? (React__default.createElement(Loading, null)) : (details.logs &&
                details.logs.map(function (log, i) { return (React__default.createElement(Timeline.Item, __assign({ key: "log".concat(i), position: log.app === 'center' ? 'left' : 'right', color: log.status === 'error' ? 'red' : 'gray' }, (i === 0
                    ? {
                        dot: React__default.createElement(ClockCircleOutlined, { style: { fontSize: '16px' } }),
                    }
                    : {})),
                    React__default.createElement("small", null, dateFormat(log.time || '', 'mmmm dS, yyyy @ h:MM:ss TT', true)),
                    React__default.createElement("br", null),
                    log.status && React__default.createElement(Status, { log: log }),
                    log.message && (React__default.createElement(Alert, { className: 'mt-1', message: log.level, showIcon: true, description: log.message, type: log.level })))); }))))));
}
var templateObject_1$r, templateObject_2$c;

function DownloadAction(_a) {
    var _this = this;
    var t = _a.t, fileTransfer = _a.fileTransfer, api = _a.api;
    var downloadLink = useRef$1(null);
    var downloadFile = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var link, anchor, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(downloadLink === null || downloadLink === void 0 ? void 0 : downloadLink.current))
                        return [2 /*return*/];
                    if (!fileTransfer.file_field)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.getDownloadLink(fileTransfer)];
                case 2:
                    link = _a.sent();
                    anchor = downloadLink.current;
                    anchor.href = link.url;
                    anchor.click();
                    openNotificationWithIcon(notification.success, t('Download started'), "".concat(fileTransfer.file_name, " (").concat(fileTransfer.file_size_str, ")"));
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    openNotificationWithIcon(notification.error, t('Error'), "".concat(t('Unable to get download token'), " ").concat(e_1));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [fileTransfer, t]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(RowActionButton, { onClick: function () { return downloadFile(); }, shape: "circle", style: { border: 'none', backgroundColor: 'transparent' } },
            React__default.createElement(Download, { size: "20" })),
        React__default.createElement("a", { href: "#", ref: downloadLink, key: fileTransfer.id, target: "_blank" })));
}

var FileTransferTable = styled(Table$1)(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  &.ant-table,\n  * .ant-table {\n    input:focus,\n    select:focus,\n    textarea:focus,\n    button:focus {\n      outline: none;\n    }\n    overflow-x: scroll;\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"], ["\n  &.ant-table,\n  * .ant-table {\n    input:focus,\n    select:focus,\n    textarea:focus,\n    button:focus {\n      outline: none;\n    }\n    overflow-x: scroll;\n  }\n  + ul.ant-table-pagination.ant-pagination {\n    float: left;\n    margin: 16px;\n  }\n\n  .ant-pagination-item-link {\n    svg {\n      vertical-align: unset;\n    }\n  }\n"])));
var templateObject_1$s;

var MenuItem = styled(Menu.Item)(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  padding: 8px 24px;\n  &:not(:last-child) {\n    border-bottom: 1px solid #eee;\n  }\n"], ["\n  padding: 8px 24px;\n  &:not(:last-child) {\n    border-bottom: 1px solid #eee;\n  }\n"])));
function FileTransferActionMenu(_a) {
    var _this = this;
    var t = _a.t, fileTransfer = _a.fileTransfer, updateFileTransfer = _a.updateFileTransfer, api = _a.api, setDetailModel = _a.setDetailModel;
    var _b = __read(useState(false), 2), isOpen = _b[0], setOpen = _b[1];
    // const [logsModal, setLogsModal] = useState(false);
    // const [expiryDate, setExpiryDate] = useState(null);
    var _c = __read(useState(null), 2), expireDateModal = _c[0], setExpireDateModal = _c[1];
    var _d = __read(useUserinfo(), 3), hasPermission = _d[0], user = _d[2];
    var addPermission = api.isCenter
        ? 'add_center_filetransfer'
        : 'add_filetransfer';
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dropdown, { trigger: ['click'], overlay: React__default.createElement(Menu, { style: { minWidth: 192 } },
                React__default.createElement(MenuItem, { disabled: !hasPermission('share_filetransfer'), onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var isPublic, id, result, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    isPublic = !fileTransfer.is_public;
                                    id = fileTransfer.id;
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, api.update({ id: id, isPublic: isPublic })];
                                case 2:
                                    result = _a.sent();
                                    updateFileTransfer(result);
                                    openNotificationWithIcon(notification.success, t('Success'), result.is_public ? t('File shared') : t('File unshared'));
                                    return [3 /*break*/, 4];
                                case 3:
                                    e_1 = _a.sent();
                                    openNotificationWithIcon(notification.error, t('Error'), String(e_1));
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); } }, fileTransfer.is_public ? t('Unshare') : t('Share')),
                React__default.createElement(MenuItem, { disabled: !hasPermission('expire_filetransfer') ||
                        (fileTransfer.user !== (user === null || user === void 0 ? void 0 : user.id) && !(user === null || user === void 0 ? void 0 : user.is_superuser)), onClick: function () { return setExpireDateModal(fileTransfer.expires_at); } }, t('Set expire date')),
                React__default.createElement(MenuItem, { disabled: !hasPermission(addPermission), 
                    // icon={<Trash size={14} />}
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, api.destroy(fileTransfer)];
                                case 1:
                                    _a.sent();
                                    fileTransfer.deleted = true;
                                    updateFileTransfer(fileTransfer);
                                    openNotificationWithIcon(notification.success, t('File deleted'), fileTransfer.file_name);
                                    return [3 /*break*/, 3];
                                case 2:
                                    e_2 = _a.sent();
                                    openNotificationWithIcon(notification.error, t('Error'), "".concat(e_2));
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); } }, t('Delete')),
                React__default.createElement(MenuItem, { disabled: !hasPermission(addPermission), 
                    // icon={<Trash size={14} />}
                    onClick: function () { return setDetailModel(fileTransfer); } }, t('Details'))) },
            React__default.createElement(RowActionButton, { onClick: function () { return setOpen(!isOpen); }, shape: "circle", style: {
                    border: 'none',
                    backgroundColor: 'transparent',
                    boxShadow: 0,
                } },
                React__default.createElement(MoreVertical, { size: "18" }))),
        React__default.createElement(Modal$1, { title: t('Set expire date'), footer: [
                React__default.createElement(Flex, { h: "end", key: "closeBtn" },
                    React__default.createElement(Button, { theming: api.appContext, variant: 'primary', ghost: true, onClick: function () { return setExpireDateModal(null); } }, t('common:Close'))),
            ], visible: !!expireDateModal, closable: false },
            React__default.createElement(FormGroup, { label: '', input: React__default.createElement(DatePicker, { showToday: false, disabledDate: function (d) {
                        return !d || d.isBefore(moment().add(0, 'day'));
                    }, onChange: function (value) { return __awaiter(_this, void 0, void 0, function () {
                        var result, e_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setExpireDateModal(value ? value.toISOString() : null);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, 4, 5]);
                                    return [4 /*yield*/, api.update({
                                            id: fileTransfer.id,
                                            expiresAt: value === null || value === void 0 ? void 0 : value.toISOString(),
                                        })];
                                case 2:
                                    result = _a.sent();
                                    updateFileTransfer(result);
                                    openNotificationWithIcon(notification.success, t('Expiry date updated'), React__default.createElement("p", null, t('File will be expired at {{date}}', {
                                        date: dateFormat(result.expires_at || '', 'mmmm dS, yyyy', true),
                                    })));
                                    return [3 /*break*/, 5];
                                case 3:
                                    e_3 = _a.sent();
                                    openNotificationWithIcon(notification.error, t('Error'), String(e_3));
                                    return [3 /*break*/, 5];
                                case 4:
                                    setExpireDateModal(null);
                                    return [7 /*endfinally*/];
                                case 5: return [2 /*return*/, true];
                            }
                        });
                    }); }, style: { minWidth: '100%' }, placeholder: t('Set expire date'), defaultValue: moment(expireDateModal) }) }))));
}
var templateObject_1$t;

var defaultValue = [
    moment().add(-1, 'month'),
    moment(),
];
var formatRange = function (values) {
    var _a = __read(values || [], 2), from = _a[0], to = _a[1];
    return {
        from: from === null || from === void 0 ? void 0 : from.startOf('day').toISOString(),
        to: to === null || to === void 0 ? void 0 : to.endOf('day').toISOString(),
    };
};
function RangePicker(_a) {
    var _b;
    var t = _a.t, onChange = _a.onChange, rest = __rest(_a, ["t", "onChange"]);
    var _c = __read(useState(defaultValue), 2), range = _c[0], setRange = _c[1];
    // const [t] = useTranslation(['common']);
    useEffect$1(function () {
        onChange(formatRange(range));
    }, [range, onChange]);
    var ranges = (_b = {},
        _b[t('Today')] = [moment(), moment()],
        _b[t('Last 7 days')] = [moment().add(-7, 'day'), moment()],
        _b[t('Last 14 days')] = [moment().add(-14, 'day'), moment()],
        _b[t('Last month')] = [moment().add(-1, 'month'), moment()],
        _b[t('Last 3 months')] = [moment().add(-3, 'month'), moment()],
        _b);
    return (React__default.createElement(DatePicker.RangePicker, __assign({ showTime: false, disabledDate: function (d) { return !d || d.isAfter(moment()); }, defaultValue: defaultValue, ranges: ranges, onChange: setRange }, rest)));
}

var Icon$1 = styled.span(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  font-size: 18px;\n"], ["\n  font-size: 18px;\n"])));
function StatusIcon(_a) {
    var status = _a.status, label = _a.label;
    label = label || status;
    var icons = {
        new: React__default.createElement(Clock, { size: 20 }),
        uploading: React__default.createElement(SyncOutlined, { spin: true }),
        syncing: React__default.createElement(SyncOutlined, { spin: true }),
        ready: React__default.createElement(Check, null),
        expired: React__default.createElement(Slash, { size: 20 }),
        error: React__default.createElement(AlertTriangle, { size: 20 }),
        locked: React__default.createElement(Shield, { size: 20 }),
    };
    return (React__default.createElement(Tooltip, { title: label },
        React__default.createElement(Icon$1, null, icons[status])));
}
var templateObject_1$u;

var UploadButton = function (_a) {
    var t = _a.t, uppy = _a.uppy, props = __rest(_a, ["t", "uppy"]);
    var uploadRef = useRef$1(null);
    var onChange = function (event) {
        var target = event.target;
        if (!target.files)
            return;
        var files = Array.from(target.files);
        files.forEach(function (file) {
            try {
                uppy.addFile({
                    source: 'file input',
                    name: file.name,
                    type: file.type,
                    data: file,
                });
            }
            catch (err) {
                /* @ts-ignore */
                if (err.isRestriction) {
                    // handle restrictions
                    console.log('Restriction error:', err);
                }
                else {
                    // handle other errors
                    console.error(err);
                }
            }
        });
    };
    // it’s probably a good idea to clear the `<input>`
    // after the upload or when the file was removed
    // (see https://github.com/transloadit/uppy/issues/2640#issuecomment-731034781)
    uppy.on('file-removed', function () {
        if (uploadRef.current)
            uploadRef.current.value = '';
    });
    uppy.on('complete', function () {
        if (uploadRef.current)
            uploadRef.current.value = '';
    });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("input", { type: "file", ref: uploadRef, onChange: onChange, style: { display: 'none' }, multiple: true }),
        React__default.createElement(Button, __assign({ ghost: false, variant: 'primary', onClick: function () { var _a; return (_a = uploadRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, props),
            React__default.createElement(Upload, { size: 16, className: 'mr-2' }),
            t('Upload file'))));
};

/* eslint-disable react/display-name */
var DATE_FORMAT = 'mmmm dS, yyyy @ h:MM:ss TT';
var fileTransferFilterKeys = [
    'file_type',
    'status_site_str',
    'status_center_str',
    'is_public',
];
var fileTransferSearchKeys = [
    'file_name',
    'user_name',
    'status_site_str',
    'status_center_str',
    'file_type',
];
var fileTransferCustomOptionLabel = function (t) { return function (key, value) {
    if (key === 'is_public') {
        switch (value) {
            case true:
                return t('Shared');
            default:
                return t('Private');
        }
    }
    return value;
}; };
var fileTransferCustomHeadingLabel = function (t) { return function (key) {
    if (key === 'file_type')
        return t('fileTransfer:File Type');
    if (key === 'is_public')
        return t('fileTransfer:Shared');
    if (key === 'status_site_str')
        return t('common:Site');
    if (key === 'status_center_str')
        return t('common:Center');
    return key;
}; };
var fileTransferColumns = function (t, api, user, updateFileTransfer, setDetailModel) { return [
    {
        title: '',
        dataIndex: 'user_name',
        key: 'user_name',
        width: 30,
        render: function (col) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Flex, { h: "center", v: "center" },
                React__default.createElement(Tooltip, { title: col },
                    React__default.createElement("span", null,
                        React__default.createElement(Initials, { name: col })))))); },
    },
    {
        title: t('File name'),
        dataIndex: 'file_name',
        key: 'file_name',
        sorter: function (a, b) { return objectArraySort(a, b, 'file_name'); },
        render: function (col, row) { return (React__default.createElement("div", null,
            React__default.createElement(Tooltip, { title: row.file_type }, col || '-'))); },
    },
    {
        title: t('Size'),
        dataIndex: 'file_size',
        key: 'file_size',
        sorter: function (a, b) { return a.file_size - b.file_size; },
        render: function (col, record) { return (React__default.createElement("div", { style: { whiteSpace: 'nowrap' }, title: col }, record.file_size_str)); },
    },
    {
        title: t('Site'),
        dataIndex: 'status_site_str',
        key: 'status_site_str',
        render: function (col, record) { return (React__default.createElement(StatusIcon, { status: record.status_site, label: col })); },
    },
    {
        title: t('Center'),
        dataIndex: 'status_center_str',
        key: 'status_center_str',
        render: function (col, record) { return (React__default.createElement(StatusIcon, { status: record.status_center, label: col })); },
    },
    {
        title: t('Shared'),
        dataIndex: 'is_public',
        key: 'is_public',
        render: function (col) {
            return col ? React__default.createElement(CheckSquare, { size: 20 }) : React__default.createElement(Square, { size: 20 });
        },
    },
    {
        title: t('Created'),
        dataIndex: 'created_at',
        key: 'created_at',
        // width: 200,
        sorter: function (a, b) { return objectArraySort(a, b, 'created_at'); },
        render: function (col) {
            var created = dateFormat(col || '', DATE_FORMAT, true);
            var createdShort = new Date(col).toLocaleDateString(user.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });
            var createdDiff = new Date().getTime() - new Date(col).getTime();
            var createdIn = humanizeDuration(createdDiff, {
                round: true,
                language: user.language,
                units: ['mo', 'd', 'h', 'm', 's'],
                largest: 1,
            });
            return (React__default.createElement(Tooltip, { title: created },
                React__default.createElement("div", null,
                    React__default.createElement("p", { className: 'mb-0', style: { whiteSpace: 'nowrap' } }, createdShort),
                    React__default.createElement("small", { className: 'text-muted' },
                        createdIn,
                        " ",
                        t('ago')))));
        },
    },
    {
        title: t('Expires'),
        dataIndex: 'expires_at',
        key: 'expires_at',
        // width: 200,
        sorter: function (a, b) { return objectArraySort(a, b, 'expires_at'); },
        render: function (col) {
            var expireDiff = new Date().getTime() - new Date(col).getTime();
            var expiresIn = humanizeDuration(expireDiff, {
                round: true,
                language: user.language,
                units: ['d'],
            });
            var expires = dateFormat(col || '', DATE_FORMAT, true);
            var expiresShort = new Date(col).toLocaleDateString(user.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });
            return (React__default.createElement(Tooltip, { title: expires },
                React__default.createElement("div", null,
                    React__default.createElement("p", { className: 'mb-0', style: { whiteSpace: 'nowrap' } }, expiresShort),
                    React__default.createElement("small", { className: 'text-muted' },
                        expiresIn,
                        " ",
                        t('left')))));
        },
    },
    {
        title: '',
        dataIndex: '',
        key: 'actions',
        render: function (col, record) {
            var status = api.isCenter ? record.status_center : record.status_site;
            var viewFileTransfer = api.isCenter
                ? 'view_center_filetransfer'
                : 'view_filetransfer';
            return (React__default.createElement(Flex, { h: 'end', key: col },
                React__default.createElement(PermissionGuard, { codename: viewFileTransfer }, status === 'ready' && (React__default.createElement(DownloadAction, { t: t, api: api, fileTransfer: record }))),
                React__default.createElement(FileTransferActionMenu, { t: t, api: api, fileTransfer: record, updateFileTransfer: updateFileTransfer, setDetailModel: setDetailModel })));
        },
    },
]; };

var baseUrl = '/api/file-transfer/';
var FileTransferApi = function (site) { return ({
    appContext: site ? 'center' : 'site',
    isCenter: !!site,
    isSite: !site,
    fetchFileTransfers: function (_a) {
        var dateRange = _a.dateRange;
        return __awaiter(void 0, void 0, void 0, function () {
            var params, url, result, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        params = [];
                        if (dateRange === null || dateRange === void 0 ? void 0 : dateRange.from)
                            params.push("created_at__gt=".concat(dateRange.from));
                        if (dateRange === null || dateRange === void 0 ? void 0 : dateRange.to)
                            params.push("created_at__lt=".concat(dateRange.to));
                        url = params.length ? "".concat(baseUrl, "?").concat(params.join('&')) : baseUrl;
                        return [4 /*yield*/, Fetch(site).get(url)];
                    case 1:
                        result = _b.sent();
                        if (result.status >= 400)
                            throw Error(result.statusText);
                        return [4 /*yield*/, result.json()];
                    case 2:
                        data = _b.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    },
    get: function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(baseUrl).concat(id, "/");
                    return [4 /*yield*/, Fetch(site).get(url)];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200)
                        throw new Error(response.statusText);
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); },
    create: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var cleanedData, body, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cleanedData = snake(pickBy(data, function (x) { return x !== undefined; }));
                    body = JSON.stringify(cleanedData);
                    return [4 /*yield*/, Fetch(site).post(baseUrl, { body: body })];
                case 1:
                    response = _a.sent();
                    if (response.status !== 201)
                        throw new Error(response.statusText);
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); },
    update: function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var id, url, cleanedData, body, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = data.id;
                    url = "".concat(baseUrl).concat(id, "/");
                    cleanedData = snake(pickBy(data, function (x) { return x !== undefined; }));
                    body = JSON.stringify(cleanedData);
                    return [4 /*yield*/, Fetch(site).patch(url, { body: body })];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200)
                        throw new Error(response.statusText);
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); },
    getDownloadLink: function (fileTansfer) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(baseUrl).concat(fileTansfer.id, "/download_link/");
                    return [4 /*yield*/, Fetch(site).get(url)];
                case 1:
                    response = _a.sent();
                    if (response.status !== 200)
                        throw new Error(response.statusText);
                    return [4 /*yield*/, response.json()];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); },
    destroy: function (fileTansfer) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "".concat(baseUrl).concat(fileTansfer.id, "/");
                    return [4 /*yield*/, Fetch(site).delete(url)];
                case 1:
                    response = _a.sent();
                    if (response.status !== 204)
                        throw new Error(response.statusText);
                    return [2 /*return*/, true];
            }
        });
    }); },
}); };

export { AccessDenied, Avatar, Button, ClipboardMenu, CompactTable, constants as Constants, DetailModal, Divider, DownloadAction, Fetch, FieldError, FileTransferActionMenu, FileTransferApi, FileTransferTable, Flex, Footer, FormGroup, Grid, IconFilm, IconMcAfee, IconRequestConnection, IconStartConnection, IconVideo, IconWindows, Initials, Loading, Logo, MssGlobalStyles, MssIcon, Page, PageContent, PageSidebar, PermissionGuard, RangePicker, regExp as Regex, RemoteClient, RemoteRecordingPlayer, RequestStatus, RowActionButton, SandboxIcon, SearchFilterDropdown, Segment, Sidebar, StatusIcon, StatusIndicator, StatusTag, Stepper, SubmitButton, Switch, TermsConditions, UploadButton, UserProvider, VerticalRadio, _fetch, _fetchSite, antdToEsSort, applicationTypeFullLabel, applicationTypeSteps, applicationTypeTableIcon, applicationTypeTableLabel, arrayContains, arrayRemove, bounceDelay$1 as bounceDelay, computeTypeSteps, computeTypeTableIcon, computeTypeTableLabel, computeTypeTableUrl, deepCopy, defaultParams, defaultSort, esToAntdSort, fieldTypeSteps, fieldTypeTableLabel, fileTransferColumns, fileTransferCustomHeadingLabel, fileTransferCustomOptionLabel, fileTransferFilterKeys, fileTransferSearchKeys, getAuthHeader, getAuthToken, getSiteHeader, keycloakEntry, networkTypeSteps, networkTypeTableIcon, networkTypeTableLabel, objectArraySort, openNotificationWithIcon, parseFlatJsonToForm$1 as parseFlatJsonToForm, plcDcsTypeSteps, plcDcsTypeTableLabel, removeSearchParam, snake, sortByCustomOrder, stringToApplicationType, stringToComputeType, stringToFieldType, stringToNetworkType, stringToPlcDcsType, theme, timeOffsetFormat, timeOffsetLabel, uniq, updateObjectInArray, useDebounce, useFetch, useFilters, useInterval, usePageQuery, useUppy, useUserinfo };
